// src/data/articles/articles.js

// --------------------------------------------
// 1) DATA
// Add as many articles as you want here.
// - Use `featured: true` on exactly one (or none).
// - `category` is used for filtering tabs.
// - `body` is optional, but Article.jsx renders it when present.
// --------------------------------------------

export const ARTICLES = [


{
  id: 2,
  featured: false,
  slug: "two-trophies-stay-in-pag-apn-2025",
  category: "News",
title: "Two Winning Trophies Stay on Pag",
  subtitle:
    "Local pizzaioli take top positions at the Mainardi Food & APN Pizza Cup, with Pag-based chefs standing on the podium in both competition categories.",
  excerpt:
    "At the Mainardi Food & APN Pizza Cup in Pag, local pizzaioli claimed podium positions in both categories — keeping two of the main trophies on the island.",
  author: "Radio Pag",
  role: "Media",
  date: "September 19, 2025",
  readTime: "3 min read",

  datePublished: "2025-09-19",
  dateModified: "2025-09-19",

  heroImage: "/img/articles/2025/mainardi4.jpeg",
  image: "/img/articles/2025/mainardi4.jpeg",
  author_image: "/logo2.avif",

  tags: ["APN", "Mainardi", "Pag", "Pizza Competition", "Winners"],
  keyStats: [
    { value: "20+", label: "Competitors" },
    { value: "5+", label: "Countries" },
    { value: "2", label: "Trophies in Pag" },
  ],

  body: [
    {
      type: "paragraph",
      dropcap: true,
      text:
        "At the Mainardi Food & APN Pizza Cup held in Pag on September 18th, with around twenty competitors from Croatia, Bosnia and Herzegovina, Slovenia, Serbia, Poland, and even the Philippines, local pizzaioli secured podium positions in both competition categories.",
      strong: ["Mainardi Food & APN Pizza Cup", "Pag", "September 18th"],
    },

    { type: "heading", text: "Pizza Napoletana STG" },
    {
      type: "paragraph",
      text:
        "In the highly demanding and strictly regulated Pizza Napoletana STG category, third place was taken by Igor Paunović from the Belgrade pizzeria Majstor & Margarita, which has been listed for years in the 50 Top Pizza Europe guide.",
      strong: ["Pizza Napoletana STG", "Igor Paunović", "Majstor & Margarita", "50 Top Pizza Europe"],
    },
    {
      type: "paragraph",
      text:
        "Second place was won by Dion Doli from Porta Salina Pag.",
      strong: ["Dion Doli", "Porta Salina Pag"],
    },
    {
      type: "paragraph",
      text:
        "First place went to Bojan Merdzanovski from the pizzeria Bell Ciao in Vir.",
      strong: ["Bojan Merdzanovski", "Bell Ciao", "Vir"],
    },

    { type: "heading", text: "Pizza Classica" },
    {
      type: "paragraph",
      text:
        "In the creative Pizza Classica category, where pizzaioli presented their own original pizza creations, third place was taken by Karlo Žanić from Brick’n’Bite in Bestovje.",
      strong: ["Pizza Classica", "Karlo Žanić", "Brick’n’Bite"],
    },
    {
      type: "paragraph",
      text:
        "Second place was won by the young Polish pizzaiolo based in Pag, Maciej Gadomski from D10’s Pizza Fantasista, with his recently introduced pizza Messi’s 30.",
      strong: ["Maciej Gadomski", "D10’s Pizza Fantasista", "Messi’s 30"],
    },
    {
      type: "paragraph",
      text:
        "First place went to Bartul Bašić from Murter with his pizza APNP — A Pag on a Pizza — using authentic ingredients found on the island.",
      strong: ["Bartul Bašić", "Murter", "APNP"],
    },

   

    { type: "heading", text: "Why This Matters" },
    {
      type: "paragraph",
      text:
        "The judging panel included the president of the Associazione Pizzaiuoli Napoletani, the 2024 world champion in pizza contemporanea Pasquale Poerio, and Croatian Trofeo Caputo winner Alen Radanović — which makes the success of Pag’s pizzaioli even more significant.",
      strong: ["Pasquale Poerio", "Alen Radanović", "Associazione Pizzaiuoli Napoletani"],
    },
    {
      type: "paragraph",
      text:
        "Organizers added that both Dion and Maciej qualified for the Trofeo Caputo in Naples with their placements and will represent Croatia next year.",
      strong: ["Trofeo Caputo", "Naples"],
    },
    {
      type: "paragraph",
      text:
        "They also noted that this experience will only raise the level of pizza on Pag even further in the future.",
    },
     {
      type: "image",
      src: "/img/articles/2025/mainardi1.jpeg",
      alt: "Mainardi APN 2025",
      caption: "Mainardi APN 2025",
    }, {
      type: "image",
      src: "/img/articles/2025/mainardi3.jpeg",
      alt: "Mainardi APN 2025",
      caption: "Mainardi APN 2025 .",
    },

    {
      type: "image",
      src: "/img/articles/2025/mainardi2.jpeg",
      alt: "Mainardi APN 2025",
      caption: "Mainardi APN 2025.",
    },
     {
      type: "image",
      src: "/img/articles/2025/mainardi4.jpeg",
      alt: "Mainardi APN 2025",
      caption: "Mainardi APN 2025 .",
    },
  {
      type: "image",
      src: "/img/articles/2025/mainardi5.jpeg",
      alt: "Mainardi APN 2025",
      caption: "Mainardi APN 2025 .",
    },  {
      type: "image",
      src: "/img/articles/2025/mainardi6.jpeg",
      alt: "Mainardi APN 2025",
      caption: "Mainardi APN 2025 .",
    }, {
      type: "image",
      src: "/img/articles/2025/mainardi8.jpeg",
      alt: "Mainardi APN 2025",
      caption: "Mainardi APN 2025 .",
    },
  ],
},


{
  id: 12,
  featured: false,
  slug: "pizza-fritta-at-d10",
  category: "Kitchen",
  title: "Pizza Fritta at D10",
  subtitle:
    "A humble Neapolitan classic born out of necessity, now prepared in two versions at D10 after learning directly from Naples-trained pizzaiolo Jernej Berlot.",
  excerpt:
    "Pizza fritta was born in difficult times when ovens were destroyed and ingredients were scarce. Today, we prepare it at D10 in two versions — classic and fantasista — with respect for its origins.",
  author: "D10 Editorial",
  role: "Kitchen",
  date: "October 21, 2025",
  readTime: "3 min read",

  datePublished: "2025-10-21",
  dateModified: "2025-10-21",

  heroImage: "/img/articles/2025/hero-fritta.avif",
  image: "/img/articles/2025/hero-fritta.avif",
  author_image: "/logo2.avif",

  tags: ["Pizza Fritta", "Naples", "D10", "Tradition", "NK Pag"],
  keyStats: [
    { value: "2", label: "Versions at D10" },
    { value: "WWII", label: "Origin period" },
    { value: "1 island", label: "Where it’s now made" },
  ],

  body: [
    {
      type: "paragraph",
      dropcap: true,
      text:
        "Last weekend at D10 pizza fantasista, we hosted Slovenian pizzaiolo and instructor Jernej Berlot, who learned the craft in Naples. He showed our team how to prepare this authentic and modest Neapolitan dish with precision and respect for its roots.",
      strong: ["Jernej Berlot", "Naples"],
    },
    {
      type: "paragraph",
      text:
        "Pizza fritta, literally meaning ‘fried pizza’, is a lesser-known Neapolitan variation that emerged during World War II. Naples was heavily bombed, ovens were destroyed, and ingredients were scarce, so people had to improvise how and with what they cooked.",
      strong: ["fried pizza", "World War II"],
    },
    {
      type: "paragraph",
      text:
        "This is one of the most common theories of its origin, although there are occasional historical records from the early 16th century that already mention fried dough and similar preparations.",
    },
     {
      type: "image",
      src: "/img/articles/2025/fritta-1.avif",
      alt: "Pizza fritta at D10",
      caption: "Pizza fritta at D10.",
    },

    { type: "quote", text: "Some of the most honest food comes from moments when people had no other choice." },

    { type: "heading", text: "How We Make It at D10" },
    {
      type: "paragraph",
      text:
        "At D10, we prepare pizza fritta in two versions. The first is a classic Margherita-style fritta. The second is Fritta Fantasista, a richer version with kulen and ricotta cheese.",
      strong: ["Classic", "Fritta Fantasista", "kulen", "ricotta"],
    },
     {
      type: "image",
      src: "/img/articles/2025/fritta-2.avif",
      alt: "Making pizza fritta",
      caption: "Making pizza fritta.",
    },
    {
      type: "paragraph",
      text:
        "The first people to taste our fritta were the players of NK Pag’s first team, who tried it before it officially appeared on the menu.",
      strong: ["NK Pag"],
    },
    {
      type: "paragraph",
      text:
        "Pizza fritta is now available on our menu, with a 20% discount for NK Pag members.",
      strong: ["20% discount"],
    },

    {
      type: "image",
      src: "/img/articles/2025/fritta-3.avif",
      alt: "NK Pag team",
      caption: "NK Pag team",
    },
  ],
},

{
  id: 3,
  featured: false,
  slug: "g10s-guest-chef-jernej-berlot-pag",
  category: "Events",
  title: "Many Pizza Styles at D10 with Guest Chef Jernej Berlot",
  subtitle:
    "As part of the #G10s guest chef series, Naples-trained Slovenian pizzaiolo Jernej Berlot brings Montanara, Canotto-style pizzas, Pizza Fritta, and sweet variations to Pag.",
  excerpt:
    "On Saturday, October 18th, D10 welcomes guest pizzaiolo Jernej Berlot, presenting several different pizza styles alongside the already familiar Ruota di Carro — including fried pizza, canotto, and sweet versions.",
  author: "D10 Editorial",
  role: "Events",
  date: "October 13, 2025",
  readTime: "2 min read",

  datePublished: "2025-10-13",
  dateModified: "2025-10-13",

  heroImage: "/img/articles/2025/jernej-g10.jpeg",
  image: "/img/articles/2025/jernej-g10.jpeg",
  author_image: "/logo2.avif",

  tags: ["G10s", "Guest Chef", "Pizza Event", "D10", "Jernej Berlot"],
  keyStats: [
    { value: "Oct 18", label: "Event date" },
    { value: "4+", label: "Pizza styles" },
    { value: "1 guest", label: "Jernej Berlot" },
  ],

  body: [
    {
      type: "paragraph",
      dropcap: true,
      text:
        "As part of the guest chef and pizzaiolo series at D10 called #G10s — short for Guest Ten — visitors on Saturday, October 18th at D10 Pizza Fantasista will be able to taste several different pizza styles in addition to the already familiar Ruota di Carro.",
      strong: ["#G10s", "October 18th", "Ruota di Carro"],
    },
    {
      type: "paragraph",
      text:
        "The guest of the evening is Jernej Berlot, an experienced Slovenian pizza master and long-time instructor, who trained in Naples and now brings that knowledge to Pag.",
      strong: ["Jernej Berlot", "Naples"],
    },

    {
      type: "image",
      src: "/img/articles/2025/jernej-g10.jpeg",
      alt: "Guest chef pizza event",
      caption: "Fig 1. Guest chef evening at D10",
    },

    { type: "heading", text: "What Will Be Served" },
    {
      type: "paragraph",
      text:
        "Jernej will present Montanara, a fried and baked hybrid pizza, Canotto-style pizzas characterized by their high, airy, inflated crust, and the traditional Neapolitan Pizza Fritta — which, unlike baked pizza, is fried in deep oil, resulting in a crispy exterior and a soft interior.",
      strong: ["Montanara", "Canotto", "Pizza Fritta"],
    },
    {
      type: "paragraph",
      text:
        "In addition, several sweet versions will be available, some of which will later remain on the permanent menu.",
      strong: ["sweet versions", "permanent menu"],
    },
    {
      type: "paragraph",
      text:
        "For pizza enthusiasts interested in the details of preparation and process, this is an ideal opportunity to learn directly from the source.",
    },

    {
      type: "image",
      src: "/img/articles/2025/jernej-adrian.avif",
      alt: "Different pizza styles",
      caption: "Fig 2. Different pizza styles presented at the event.",
    },

  {
  type: "paragraph",
  text: "Reservations via Instagram @d10spizza or WhatsApp at +385 95 501 1065.",
  links: [
    { text: "@d10spizza", href: "https://www.instagram.com/d10spizza/", external: true },
    { text: "+385 95 501 1065", href: "tel:+385955011065" }
  ],
  strong: ["Reservations"]
}

  ],
},
{
  id: 4,
  featured: false,
  slug: "first-g10s-guest-chef-magda-gadomska",
  category: "Events",
  title: "The First #G10s Guest Chef Arrives in Pag",
  subtitle:
    "D10 launches its new guest chef series with Polish chef Magda Gadomska, bringing pierogi, mielone, and her signature pizza Čečotina to Pag.",
  excerpt:
    "This Thursday, D10 starts the #G10s series — a lineup of guest chefs and pizzaioli bringing new, pizza-inspired specialties from across Europe to Pag.",
  author: "D10 Editorial",
  role: "Events",
  date: "October 01, 2025",
  readTime: "2 min read",

  datePublished: "2025-10-01",
  dateModified: "2025-10-01",

  heroImage: "/img/articles/2025/covermagda.jpeg",
  image: "/img/articles/2025/covermagda.jpeg",
  author_image: "/logo2.avif",

  tags: ["G10s", "Guest Chef", "Polish Cuisine", "D10", "Magda Gadomska"],
  keyStats: [
    { value: "1st", label: "G10s event" },
    { value: "3+", label: "Polish dishes" },
    { value: "19:00", label: "Start time" },
  ],

  body: [
    {
      type: "paragraph",
      dropcap: true,
      text:
        "This Thursday, D10’s Pizza Fantasista launches a new series of guest chefs and pizzaioli called #G10s — short for Guest Ten — bringing pizza-inspired specialties from across Europe to Pag.",
      strong: ["#G10s", "Guest Ten"],
    },
    {
      type: "paragraph",
      text:
        "As part of the series, different guest chefs will prepare and serve unique dishes at Prosika that are inspired by pizza culture but reflect flavors from other European cities.",
    },

    {
      type: "image",
      src: "/img/articles/2025/magdag10.avif",
      alt: "Guest chef event",
      caption: "First #G10s guest chef evening at D10.",
    },

    { type: "heading", text: "Meet the First Guest Chef" },
    {
      type: "paragraph",
      text:
        "The first guest chef to present at #G10s is Magda Gadomska, who brings Polish specialties such as pierogi, mielone, and her bistro’s most popular pizza, Čečotina.",
      strong: ["Magda Gadomska", "pierogi", "mielone", "Čečotina"],
    },
    {
      type: "paragraph",
      text:
        "Magda is the owner of the popular and distinctive bistro Little Madza Lubi in Czeczotki near Warsaw, known for its creative and personal approach to Polish comfort food.",
      strong: ["Little Madza Lubi", "Czeczotki", "Warsaw"],
    },
    {
      type: "paragraph",
      text:
        "Beyond her bistro, Magda regularly presents her cuisine at events and on cooking shows on Polish national television, earning a loyal following who affectionately call her Madža.",
      strong: ["Polish national television", "Madža"],
    },

     {
      type: "image",
      src: "/img/articles/2025/magda2.jpeg",
      alt: "Guest chef event",
      caption: "First #G10s guest chef evening at D10.",
    },

    { type: "heading", text: "When and Where" },
    {
      type: "paragraph",
      text:
        "You can try Magda’s dishes this Thursday at Prosika 51A, starting at 19:00.",
      strong: ["Prosika 51A", "19:00"],
    },
    {
  type: "paragraph",
  text: "Reservations via Instagram @d10spizza or WhatsApp at +385 95 501 1065.",
  links: [
    { text: "@d10spizza", href: "https://www.instagram.com/d10spizza/", external: true },
    { text: "+385 95 501 1065", href: "tel:+385955011065" }
  ],
  strong: ["Reservations"]
}

  ],
},
{
  id: 6,
  featured: false,
  slug: "mainardi-apn-pizza-cup-pag-2025",
  category: "Events",
  title: "Mainardi & APN Pizza Cup Pag 2025",
  subtitle:
    "An international pizzaiolo competition qualifying for Trofeo Caputo in Naples, hosted for the first time in Pag.",
  excerpt:
    "On August 19th, 2025, Pag hosts the Mainardi & APN Pizza Cup — an international qualification event where pizzaioli compete for a place at the Trofeo Caputo world championship in Naples.",
  author: "D10 Editorial",
  role: "Events",
  date: "September 01, 2025",
  readTime: "3 min read",

  datePublished: "2025-09-01",
  dateModified: "2025-09-01",

  heroImage: "/img/articles/2025/mainardihero.jpeg",
  image: "/img/articles/2025/mainardi.avif",
  author_image: "/logo2.avif",

  tags: ["APN", "Mainardi", "Pizza Competition", "Trofeo Caputo", "Pag"],
  keyStats: [
    { value: "Sep 19", label: "Event date" },
    { value: "11:00", label: "Start time" },
    { value: "2", label: "Competition categories" },
  ],

  body: [
    {
      type: "paragraph",
      dropcap: true,
      text:
        "Croatian pizzerias and pizzaioli have become an increasingly recognized part of the international pizza community. In recent years, Croatian pizzerias have appeared in major European and global guides, and Croatian pizzaioli have achieved top results at international competitions.",
      strong: ["Croatian pizzaioli", "international pizza community"],
    },
    {
      type: "paragraph",
      text:
        "Over the past three years, Croatian pizzaioli have brought home two gold medals from the Trofeo Caputo, the world championship of pizzaioli traditionally held each year in Naples.",
      strong: ["Trofeo Caputo", "Naples"],
    },

    { type: "heading", text: "Previous Winners" },
    {
      type: "paragraph",
      text:
        "In 2023, the Croatian national team won gold in the national teams category, represented by Boris Lukšić from Franko’s in Zagreb, and Tomislav Perić and Alen Radanović from Novi Saloon in Osijek.",
      strong: ["Boris Lukšić", "Tomislav Perić", "Alen Radanović", "Franko’s", "Novi Saloon"],
    },
    {
      type: "paragraph",
      text:
        "In 2024, Alen Radanović repeated the success individually by winning first place in the Pizza Stagioni category.",
      strong: ["Pizza Stagioni"],
    },

    {
      type: "image",
      src: "/img/articles/2025/mainardi.avif",
      alt: "Pizza competition",
      caption: "Fig 1. Competition atmosphere.",
    },

    { type: "heading", text: "How to Qualify" },
    {
      type: "paragraph",
      text:
        "The path to Trofeo Caputo is simple: by winning a local qualification competition organized by Mainardi Food and the Associazione Pizzaiuoli Napoletani (APN).",
      strong: ["Mainardi Food", "APN"],
    },
    {
      type: "paragraph",
      text:
        "This year, the qualification will take place for the first time in Pag, on the city beach Prosika.",
      strong: ["Prosika", "Pag"],
    },

    

    { type: "heading", text: "Competition Details" },
    {
      type: "paragraph",
      text:
        "The main prize is qualification for Trofeo Caputo in Naples. Pizzaioli will compete in two categories: Pizza Napoletana STG and Pizza Classica.",
      strong: ["Pizza Napoletana STG", "Pizza Classica"],
    },
    {
      type: "paragraph",
      text:
        "The competition is international, and pizzaioli can apply regardless of which country or pizzeria they come from.",
      strong: ["international"],
    },

    { type: "heading", text: "Registration" },
    {
      type: "paragraph",
      text:
        "The application form is available via the registration link below.",
    },
    {
  type: "paragraph",
  text: "Apply here",
  links: [{ text: "Apply here", href: "https://docs.google.com/forms/d/e/1FAIpQLSdy7osBeB_UmoVla96yduVbjUWFLKW50oSeC_PtDl7cWw7aCQ/viewform?usp=send_form", external: true }]
}

  ],
},

{
  id: 1,
  featured: false,
  slug: "d10s-pizza-academy-pag-launch",
  category: "News",
  title: "D10’s Pizza Academy Launches in Pag",
  subtitle:
    "Croatia’s first pizza academy opens on the island of Pag, combining professional training, international expertise, and a new off-season reason to visit the island.",
  excerpt:
    "D10’s Pizza Academy Pag will open this spring as Croatia’s first dedicated pizza academy, aiming to train a new generation of pizzaioli and position Pag as a year-round culinary destination.",
  author: "D10’s Pizza Academy",
  role: "Editorial",
  date: "January 14, 2026",
  readTime: "4 min read",

  datePublished: "2026-01-14",
  dateModified: "2026-01-14",

  heroImage: "/img/articles/2026/d10-academy-hero.png",
  image: "/img/articles/2026/d10-academy-hero.png",
  author_image: "/logo2.avif",

  tags: ["D10", "Pizza Academy", "Pag", "Hospitality", "Education", "Tourism"],
  keyStats: [
    { value: "12", label: "Participants per group" },
    { value: "4+", label: "Confirmed instructors" },
    { value: "1st", label: "Pizza academy in Croatia" },
  ],

  body: [
    {
      type: "paragraph",
      dropcap: true,
      text:
        "This spring, the island of Pag will become home to Croatia’s first pizza academy. Under the name D10’s Pizza Academy Pag, the project aims to create a permanent center for training pizza enthusiasts, professional pizzaioli, and pizzeria managers — while also giving Pag a new reason to be visited beyond the summer season.",
      strong: ["D10’s Pizza Academy Pag", "Croatia’s first pizza academy", "Pag"],
    },

    { type: "heading", text: "From Beach Pizzeria to Pizza Academy" },
    {
      type: "paragraph",
      text:
        "The academy builds on the success of D10’s Pizza Fantasista, opened in the summer of 2025 on Prosika beach in Pag. The pizzeria quickly became known not only for its ruota di carro Neapolitan pizzas, but also for its unique beachfront location, football-inspired concept, and international team.",
      strong: ["D10’s Pizza Fantasista", "Prosika beach", "ruota di carro"],
    },
    {
      type: "paragraph",
      text:
        "In September 2025, the team hosted the international Mainardi & APN Pizza Cup Pag, where local pizzaioli reached podium positions in both categories — confirming Pag’s growing reputation on the European pizza map and making the academy a natural next step.",
      strong: ["Mainardi & APN Pizza Cup Pag", "podium positions"],
    },


    { type: "heading", text: "Why the Academy Was Created" },
    {
      type: "paragraph",
      text:
        "The idea behind the academy is both educational and strategic. On one side, it addresses one of the biggest challenges of the pizza industry in Croatia and beyond — the shortage of highly trained, reliable professionals. On the other, it positions Pag as a destination for learning, not just tourism.",
      strong: ["shortage of highly trained professionals", "year-round destination"],
    },
    {
      type: "paragraph",
      text:
        "Through structured programs, the academy aims to train complete, work-ready pizzaioli and support their careers through direct cooperation with partner pizzerias across the region and Europe.",
      strong: ["work-ready pizzaioli", "partner pizzerias"],
    },

    { type: "heading", text: "Training, Careers, and Access" },
    {
      type: "paragraph",
      text:
        "Professional training programs are developed together with partner pizzerias, including co-funding models that allow talented candidates to access education even if they cannot afford it themselves — while guaranteeing them employment after graduation.",
      strong: ["co-funding models", "guaranteed employment"],
    },
    {
      type: "paragraph",
      text:
        "This approach connects education directly with real market needs and creates a sustainable pipeline of talent for the hospitality industry.",
      strong: ["sustainable pipeline of talent"],
    },

    { type: "heading", text: "Partners and Supporters" },
    {
      type: "paragraph",
      text:
        "Among the first supporters of the project are the City of Pag, premium Italian product distributor Mia Familia, Croatia’s leading catering company Catering Kvatrić, Poland’s Zielona Górka from the 50 Top Pizza list, Franko’s Pizza & Bar, and Zagreb’s Pizzeria 14.",
      strong: ["City of Pag", "Mia Familia", "Catering Kvatrić", "Zielona Górka", "Franko’s Pizza & Bar", "Pizzeria 14"],
    },

    { type: "heading", text: "Confirmed Instructors" },
    {
      type: "paragraph",
      text:
        "The first confirmed instructors include Mario Markušić from Franko’s in Zagreb, experienced Split-based pizzaiolo Adrian Fetahu, Nikša Čulić from Pizzeria 14, and as a special guest Jędrzej Lewandowski, owner of Zielona Górka — named the world’s best pizzeria by AVPN in 2024.",
      strong: ["Mario Markušić", "Adrian Fetahu", "Nikša Čulić", "Jędrzej Lewandowski", "AVPN 2024"],
    },

    
    { type: "heading", text: "First International Presentation" },
    {
      type: "paragraph",
      text:
        "The academy will be officially presented on January 22–23 in Warsaw, where the pizza showroom Jak u Mammy will be transformed into a temporary D10’s Pag space to inspire young pizza enthusiasts to come to Croatia for training and work.",
      strong: ["January 22–23", "Warsaw", "Jak u Mammy"],
    },
{ type: "heading", text: "Warsaw Presentation — Agenda" },

{
  type: "list",
  items: [
    "Location: Jak u Mammy pizza showroom, Warsaw",
    "Dates: January 22–23, 2026",
    "Format: Workshops, tastings, talks, and official academy presentation",
  ],
},


{
  type: "list",
  items: [
    "Thursday, January 22",
    "12:00–14:00 Dough Talks — dough-making workshop with free coffee (supported by Solana Pag)",
    "15:00–16:00 Pag cheese story and tasting, including Franko’s Island 14 and D10’s Dalma pizzas (supported by Sirana Pag)",
    "17:00–19:00 D10’s story about pizza and football — brand story, NK Pag partnership, football beer label, short quiz, awards, free beer and pizza tasting",
  ],
},

{
  type: "list",
  items: [
    "Friday, January 23",
    "12:00–14:00 Ruota di Carro basics workshop",
    "15:00–17:00 D10’s football-inspired menu presentation with free pizza tasting (supported by Mia Familia)",
    "17:00–19:00 D10’s Pizza Academy Pag — official concept presentation, partner pizzerias and potential employers (Franko’s Pizza & Bar, Pizzeria 14), informal pizza talks with future students and free NK Pag beer",
  ],
},

    {
      type: "image",
      src: "/img/articles/2026/d10-academy-1.png",
      alt: "D10’s Pizza Academy Pag",
      caption: "The future home of D10’s Pizza Academy in Pag.",
    },
  ],
},
{
  id: 10,
  featured: false,
  slug: "pag-pizza-academy-opens-doors-2026",
  category: "Academy",
  title: "Pag Pizza Academy Opens Its Doors: Date Announced",
  subtitle: "The first workshop will be open to the public – everyone is welcome.",
  excerpt:
    "After strong public interest and numerous inquiries, Pag Pizza Academy officially announces its opening at D10’s Pizza Fantasista on Prosika beach.",
  author: "D10 Editorial",
  role: "Academy",
  date: "March 3, 2026",
  readTime: "6 min read",

  datePublished: "2026-03-03",
  dateModified: "2026-03-03",

  heroImage: "/img/articles/2026/academy-launch.jpeg",
  image: "/img/articles/2026/academy-launch.jpeg",
  author_image: "/logo2.avif",

  tags: ["Pag Pizza Academy", "D10’s Pizza Fantasista", "Pizza Education", "Prosika", "Pag"],

  keyStats: [
    { value: "3", label: "Programs" },
    { value: "Mar 14", label: "Open Workshop" },
    { value: "12–19", label: "Workshop Hours" },
  ],

  body: [
    {
      type: "paragraph",
      dropcap: true,
      text:
        "After significant interest following numerous media articles and many inquiries about our programs and opening timeline, we decided to clearly explain what will happen and when at this new place in the town of Pag.",
    },
    {
      type: "paragraph",
      text:
        "The Academy will be located next to Pag’s main town beach, Prosika, inside the well-known D10’s Pizza Fantasista venue.",
      strong: ["Prosika", "D10’s Pizza Fantasista"],
    },

    { type: "heading", text: "Who Is It For" },

    {
      type: "paragraph",
      text:
        "When asked who the Academy is designed for, founder Ivan Šetka explained it is open to anyone interested in pizza. That includes enthusiasts who want to learn how to make pizza, people who want to become professional pizzaioli, and managers or owners who want to elevate how their pizzeria works.",
      strong: ["Ivan Šetka", "Pag Pizza Academy"],
    },
    {
      type: "paragraph",
      text: "That is why we created three structured programs.",
    },

    { type: "heading", text: "Three Programs" },

    {
      type: "list",
      tone: "card",
      items: [
        {
          text:
            "Playmaker – one-day workshops where participants work in groups and learn directly from professional pizzaioli how dough is prepared and how pizza is made.",
          strong: ["Playmaker"],
        },
        {
          text:
            "Captain – a serious six-day course where participants learn across a full work week: dough technique, fermentation, oven work, and the business processes inside a pizzeria. Partner pizzerias are included, and the best participants may continue working after the course.",
          strong: ["Captain"],
        },
        {
          text:
            "Manager – the most demanding track: a two-week individual course for pizzeria owners and managers, covering every segment of operations in detail.",
          strong: ["Manager"],
        },
      ],
    },

    { type: "heading", text: "Instructors" },

    {
      type: "paragraph",
      text:
        "Mario Markušić (Franko’s Pizza & Bar, Zagreb) does not need much introduction. Five years on the 50 Top Pizza Europe list, a place among the 100 best pizzerias in the world, and many other awards speak for themselves. Mario is the person behind those recognitions, and he will transfer that knowledge and experience to participants at Pag Pizza Academy — see the Franko’s Pizza & Bar – 50 Top Pizza profile for reference.",
      strong: ["Mario Markušić", "Franko’s Pizza & Bar", "50 Top Pizza Europe", "Pag Pizza Academy"],
      links: [
        {
          text: "Franko’s Pizza & Bar – 50 Top Pizza",
          href: "https://www.50toppizza.it/referenza/frankos-pizza-bar-4/",
          external: true,
        },
      ],
    },
    {
      type: "image",
      src: "/img/articles/2026/mario-markusic.jpeg",
      alt: "Mario Markušić – Franko’s Pizza & Bar",
      caption: "Mario Markušić (Franko’s Pizza & Bar, Zagreb).",
    },

    {
      type: "paragraph",
      text:
        "In professional circles, ten years of experience is often considered the minimum to call someone a master of the craft. Adrian Fetahu (Split) has far more than that, even if he would never say it himself. He has delivered many projects quietly from the background, co-authored the first D10’s menu, and was among the first instructors mentoring our team when we were just starting.",
      strong: ["Adrian Fetahu", "Split", "D10’s"],
     links: [
        {
          text: "first D10’s menu",
          href: "https://www.jutarnji.hr/dobrahrana/price/kad-se-spoje-dobra-pizza-i-nogomet-na-pagu-je-otvorena-nova-pizzerija-ekipa-koja-iza-svega-stoji-ima-ozbiljne-planove-15596649",
          external: true,
        },
      ],
    },
    {
      type: "image",
      src: "/img/articles/2026/adrian-fetahu.jpeg",
      alt: "Adrian Fetahu – Split",
      caption: "Adrian Fetahu (Split).",
    },

    {
      type: "paragraph",
      text:
        "Although the youngest by age, Nikša Čulić (Pizzeria 14, Zagreb) brings a strong track record from top pizzerias. Used to working under pressure, always positive, he joins the instructor team with great energy. His pizza journey started at Basta (Split), and he upgraded his skills and experience at Franko’s (Zagreb).",
      strong: ["Nikša Čulić", "Pizzeria 14", "Basta", "Franko’s"],
      links: [
        {
          text: "upgraded his skills and experience at Franko’s",
          href: "https://plavakamenica.hr/2024/02/07/tajne-ulaska-u-50-top-pizza-europe-evo-kako-se-tocno-proizvodi-tijesto-za-frankosove-pizze/",
          external: true,
        },
      ],
    },
    {
      type: "image",
      src: "/img/articles/2026/niksa-culic.jpeg",
      alt: "Nikša Čulić – Pizzeria 14",
      caption: "Nikša Čulić (Pizzeria 14, Zagreb).",
    },

    { type: "heading", text: "Special Guest Supervisors" },

    {
      type: "paragraph",
      text:
        "As special instructors and supervisors ensuring everything follows the highest professional standards, two globally recognized names are joining the Academy.",
    },

    {
  type: "paragraph",
  text:
    "Jędrzej Lewandowski – the driving force and owner of the famous Polish pizzeria Zielona Górka, present for years on the 50 Top Pizza Europe and World lists. AVPN named it the best pizzeria in the world for 2024.",
  strong: ["Jędrzej Lewandowski", "Zielona Górka", "AVPN", "50 Top Pizza Europe"],
  links: [
    {
      text: "best pizzeria in the world for 2024",
      href: "https://www.pmq.com/avpns-best-neapolitan-pizzeria-in-the-world-started-out-in-the-owners-garage/",
      external: true,
    },
  ],
},
{
  type: "image",
  src: "/img/articles/2026/lewandowski.jpeg",
  alt: "Jędrzej Lewandowski – Zielona Górka",
  caption: "Jędrzej Lewandowski (Zielona Górka, Poland). Foto by Marcin Stępień ",
},

{
  type: "paragraph",
  text:
    "Cristiano de Rinaldi – a native Neapolitan and one of the most promising experts in traditional Neapolitan pizza. His family pizzeria Casa de Rinaldi was named best in the world by AVPN in 2022, appears regularly on the 50 Top Pizza Italia list, and Cristiano himself won 1st place at the Olympics of authentic Neapolitan pizza.",
  strong: ["Cristiano de Rinaldi", "Casa de Rinaldi", "AVPN", "50 Top Pizza Italia"],
  links: [
    {
      text: "named best in the world by AVPN in 2022",
      href: "https://www.derinaldi.it/it/63-casa_de_rinaldi_conquista_anche_il_titolo_di_best_avpn_pizzeria_2022",
      external: true,
    },
    {
      text: "50 Top Pizza Italia list",
      href: "https://www.50toppizza.it/referenza/casa-de-rinaldi-4/",
      external: true,
    },
  ],
},
{
  type: "image",
  src: "/img/articles/2026/cristiano-de-rinaldi.jpg",
  alt: "Cristiano de Rinaldi – Casa de Rinaldi",
  caption: "Cristiano de Rinaldi (Casa de Rinaldi, Naples).",
},

    { type: "heading", text: "More Than Certificates" },

    {
      type: "paragraph",
      text:
        "The Academy story is broader than it looks at first. It includes a network of partner pizzerias, where the best participants will have the opportunity to start working immediately after completing their program.",
      strong: ["partner pizzerias"],
    },

    {
      type: "paragraph",
      text:
        "The goal is not only to run dough courses and issue certificates, but to prepare participants for what truly awaits them in professional kitchens. That means understanding processes and arriving as a real reinforcement to the team they join. That is why cooperation with partner pizzerias has been arranged: participants who show capacity, interest, and talent will receive continued guidance and support for their professional path even after graduation.",
    },

    { type: "heading", text: "First Open Workshop: March 14" },

    {
      type: "paragraph",
      text:
        "The first demonstration and free workshop for pizza enthusiasts, curious visitors, our local community, and anyone who happens to be in Pag will take place on Saturday, March 14, from 12:00 to 19:00 at Prosika 51a.",
      strong: ["Saturday, March 14", "12:00 to 19:00", "Prosika 51a", "Pag"],
    },

    {
      type: "paragraph",
      text:
        "Whenever your schedule allows during those hours, feel free to stop by D10. You will be able to talk to our instructors, ask anything you want, stretch dough, and bake pizza.",
      strong: ["D10"],
    },

    { type: "heading", text: "When Do Programs Start" },

    {
      type: "paragraph",
      text:
        "The first program cycles for enrolled participants are planned for mid-April, after Easter.",
      strong: ["mid-April", "after Easter"],
    },

    {
      type: "paragraph",
      text:
        "Applications for the Playmaker, Captain, and Manager programs will be available via the D10 website, with details, dates, and sign-up instructions published there.",
      strong: ["Playmaker", "Captain", "Manager"],
      links: [
        {
          text: "D10 website",
          href: "https://www.d10s.pizza/academy",
          external: true,
        },
      ],
    },

    {
      type: "image",
      src: "/img/articles/2026/workshop-announce.jpeg",
      alt: "Pag Pizza Academy at D10’s Pizza Fantasista on Prosika",
      caption: "Fig 1. Pag Pizza Academy at D10’s Pizza Fantasista, Prosika.",
    },
  ],
},
{
  id: 11,
  featured: false,
  slug: "pizza-workshop-at-maria-curie-school",
  category: "Academy",
  title: "Pizza Workshop Brings Neapolitan Tradition to Maria Skłodowska-Curie High School",
  subtitle: "A hands-on culinary experience inspired by Pag’s pizza culture.",
  excerpt:
    "Student Wojciech Filipczak organized a full pizza workshop at his high school, sharing skills learned on the Croatian island of Pag and bringing authentic Neapolitan pizza closer to his local community.",
  author: "D10 Editorial",
  role: "Academy",
  date: "March 9, 2026",
  readTime: "5 min read",

  datePublished: "2026-03-09",
  dateModified: "2026-03-09",

  heroImage: "/img/articles/2026/poland2.jpeg",
  image: "/img/articles/2026/poland2.jpeg",
  author_image: "/logo2.avif",

  tags: [
    "Pizza Workshop",
    "Neapolitan Pizza",
    "Pag",
    "D10’s Pizza Fantasista",
    "Pizza Education"
  ],

  keyStats: [
    { value: "1", label: "School Workshop" },
    { value: "10+", label: "Participants" },
    { value: "100%", label: "Hands-On Experience" },
  ],

  body: [
    {
      type: "paragraph",
      dropcap: true,
      text:
        "My name is Wojciech Filipczak, and on February 17, I organized and led a pizza workshop at my school — Maria Skłodowska-Curie High School in Rawa Mazowiecka.",
    },

    {
      type: "image",
      src: "/img/articles/2026/poland3.jpeg",
      alt: "Pizza workshop at school",
      caption: "Introduction to the pizza workshop.",
    },

    {
      type: "paragraph",
      text:
        "My journey with pizza began on the Croatian island of Pag, where I worked at D10 Pizza Fantasista. What started as a job quickly became something more — a way to understand the rhythm, discipline, and simplicity behind authentic Neapolitan pizza.",
    },

    {
      type: "paragraph",
      text:
        "It wasn’t just about recipes or technique. It was about people, mindset, and the feeling of working inside a team where every pizza matters. That’s what I wanted to bring back with me.",
    },

  
    {
      type: "heading",
      text: "From Pag to the Classroom",
    },

    {
      type: "paragraph",
      text:
        "The workshop started with a presentation. I walked students and teachers through the full process — from dough preparation and fermentation to ingredient selection and baking at high temperatures.",
    },

    {
      type: "paragraph",
      text:
        "Alongside the technical side, I shared my experience of arriving on Pag. A place where food, people, and lifestyle naturally connect, and where pizza is not rushed — it’s respected.",
    },

    {
      type: "image",
      src: "/img/articles/2026/poland4.jpeg",
      alt: "Students listening",
      caption: "Students and teachers during the presentation.",
    },

    {
      type: "paragraph",
      text:
        "Through that, the workshop became more than just learning how to make pizza. It became a small window into the atmosphere of the island itself.",
    },

    {
      type: "heading",
      text: "Learning by Doing",
    },

    {
      type: "paragraph",
      text:
        "After the introduction, we moved straight into practice. Everyone who wanted to participate had the chance to make their own pizza.",
    },

    {
      type: "image",
      src: "/img/articles/2026/poland5.jpeg",
      alt: "Making pizza",
      caption: "Stretching dough and preparing pizzas.",
    },

    {
      type: "paragraph",
      text:
        "Step by step, students and teachers went through the full process — stretching dough, choosing ingredients, and understanding how small details change the final result.",
    },

    {
      type: "image",
      src: "/img/articles/2026/poland6.jpeg",
      alt: "Pizza baking",
      caption: "Baking pizzas in a professional setup.",
    },

    {
      type: "paragraph",
      text:
        "To make it as real as possible, we used a professional pizza oven provided by a Warsaw-based restaurant, Jak U Mammy. That detail changed everything — suddenly it wasn’t a school workshop anymore, it felt like a real kitchen.",
    },

    {
      type: "heading",
      text: "More Than Just One Day",
    },

    {
      type: "image",
      src: "/img/articles/2026/poland7.jpeg",
      alt: "Workshop atmosphere",
      caption: "Atmosphere during the workshop.",
    },

    {
      type: "paragraph",
      text:
        "The workshop also opened the door to something bigger. Participants learned they can continue developing their skills through programs at the D10 Pizza Academy, where knowledge is transferred directly from people working at a high international level.",
    },

    {
      type: "paragraph",
      text:
        "To bring that world closer, I shared visuals and moments from Pag — the oven, the pace, the team, and the small details that make the difference.",
    },

    {
      type: "image",
      src: "/img/articles/2026/poland8.jpeg",
      alt: "Group photo",
      caption: "Participants after the workshop.",
    },

    {
      type: "paragraph",
      text:
        "Seeing so many students and teachers genuinely engaged in the process was the best part. You could feel the curiosity — not just about pizza, but about where it can take you.",
    },

    
    {
      type: "paragraph",
      text:
        "What made it even more special was hearing that many of them now want to visit Pag themselves. That connection — between a small island and a school far away — is something I didn’t expect, but it makes complete sense.",
    },

    {
      type: "paragraph",
      text:
        "In the end, this wasn’t just a workshop. It was a simple idea: take something real, something you experienced, and pass it on. And sometimes, that’s enough to connect people, places, and stories.",
    },
  ],
},
{
  id: 13,
  featured: false,
  slug: "pag-pizza-academy-first-intensive-training",
  category: "Academy",
  title: "First Intensive Training Completed at Pag Pizza Academy",
  subtitle:
    "A new generation of pizzaioli begins their journey through hands-on training, real kitchen simulations, and local inspiration on the island of Pag.",
  excerpt:
    "Pag Pizza Academy has completed its first intensive training, where participants learned through real kitchen work, live service simulation with NK Pag, and created a special pizza for the upcoming Kaloka Festival.",
  author: "D10 Editorial",
  role: "Academy",
  date: "April 21, 2026",
  readTime: "5 min read",

  datePublished: "2026-04-21",
  dateModified: "2026-04-21",

  heroImage: "/img/articles/2026/pizza-academy/team-pizza-academy.jpeg",
  image: "/img/articles/2026/pizza-academy/team-pizza-academy.jpeg",
  author_image: "/logo2.avif",

  tags: ["Pag Pizza Academy", "D10", "Training", "Pizza", "Pag"],

  keyStats: [
    { value: "1st", label: "Intensive Training" },
    { value: "12", label: "Participants" },
    { value: "100%", label: "Moved to Kitchens" },
  ],

  body: [
    {
      type: "paragraph",
      dropcap: true,
      text:
        "Grateful and proud. That is the best way to describe how we feel after completing the first intensive training at Pag Pizza Academy. Over the past days, we worked with a group of participants who brought energy, focus, and trust into every part of the program, creating an atmosphere closer to a real kitchen than a classroom.",
    },

    {
      type: "paragraph",
      text:
        "This program was designed as a practical, hands-on experience for people who want to understand pizza at a deeper level. From dough preparation and fermentation to shaping, baking, and workflow, every step was built around real processes used in professional kitchens.",
    },

    {
      type: "image",
      src: "/img/articles/2026/pizza-academy/d10s-pizza-academy.jpeg",
      alt: "Pag Pizza Academy training",
      caption: "Hands-on training at Pag Pizza Academy.",
    },

    {
      type: "paragraph",
      text:
        "The training was led by Mario Markušić, the lead instructor of the program, who guided participants through every stage of pizza-making with precision and clarity.",
      strong: ["Mario Markušić"],
      links: [
        {
          text: "Mario Markušić",
          href: "https://www.frankos.hr/",
          external: true,
        },
        {
          text: "Franko’s Pizza & Bar",
          href: "https://www.frankos.hr/",
          external: true,
        },
      ],
    },

    {
      type: "paragraph",
      text:
        "Working with experienced professionals in a structured environment allowed participants to understand not only how to make pizza, but how to work consistently under real conditions. Small details, repetition, and discipline were a constant focus throughout the training.",
    },

    {
      type: "image",
      src: "/img/articles/2026/pizza-academy/d10skitchen.jpeg",
      alt: "Pizza training process",
      caption: "From dough to oven, every step matters.",
    },

    {
      type: "paragraph",
      text:
        "All ingredients and materials used during the program were provided in collaboration with Mia Familia, ensuring that participants worked with high-quality products from the start and understood the importance of raw materials in the final result.",
      strong: ["Mia Familia"],
    },

    {
      type: "paragraph",
      text:
        "One of the most important moments of the training came on the final day, when participants entered a live service simulation. Guests from NK Pag joined as part of the experience, creating a real service environment where timing, coordination, and teamwork became just as important as technique.",
      strong: ["NK Pag", "live service simulation"],
      links: [
        {
          text: "NK Pag",
          href: "https://nkpag.hr/",
          external: true,
        },
      ],
    },

    {
      type: "image",
      src: "/img/articles/2026/pizza-academy/d10s-pizza-course.jpeg",
      alt: "Live service simulation",
      caption: "Final day service simulation with NK Pag guests.",
    },

    {
      type: "paragraph",
      text:
        "Alongside the technical work, participants also developed their own ideas. As part of the program, they created a special Pag-inspired pizza that will be presented at the upcoming Kaloka Festival, connecting what they learned with the identity of the island.",
      strong: ["Pag-inspired pizza", "Kaloka Festival"],
      links: [
        {
          text: "Kaloka Festival",
          href: "https://www.instagram.com/kalokafestival/",
          external: true,
        },
      ],
    },

    {
      type: "paragraph",
      text:
        "What makes this first training especially meaningful is what happened immediately after. All participants are already continuing their journey in professional kitchens this week. That is the strongest confirmation that knowledge, effort, and the right environment lead to real opportunities.",
      strong: ["professional kitchens"],
    },

    {
      type: "image",
      src: "/img/articles/2026/pizza-academy/adrian-fetahu-milica-kocic.jpeg",
      alt: "Participants",
      caption: "Pag-inspired pizza for Kaloka Festival.",
    },

    {
      type: "paragraph",
      text:
        "This is only the beginning. What started as an idea is now becoming a platform where people can learn, grow, and move directly into real work. Pag Pizza Academy is not just about making pizza, but about building a mindset and a foundation for long-term development.",
    },

   {
  type: "paragraph",
  text:
    "Thank you to everyone who was part of this first chapter. We are just getting started, and we are already looking forward to the next training. Don’t wait, apply now for our next course on our website.",
  links: [
    {
      text: "apply now for our next course",
      href: "https://www.d10s.pizza/academy",
      external: true,
    },
  ],
},
    {
      type: "image",
      src: "/img/articles/2026/pizza-academy/diploma-pizza-academy.jpeg",
      alt: "Participants",
      caption: "Diplomas from Pizza Academy.",
    },
{
      type: "image",
      src: "/img/articles/2026/pizza-academy/mario-markusic.jpeg",
      alt: "Participants",
      caption: "Proud guest instructor Mario Markušić.",
    },

  ],
},
{
  id: 14,
  featured: false,
  slug: "da-nanni-barcelona-masterclass-pag",
  category: "Events",
  title: "50 Top Pizza Masterclass and Guest Popup in Pag",
  subtitle:
    "D10’s Pizza Fantasista hosts Da Nanni Barcelona, one of the world’s recognized pizza chains, for a special masterclass and one-night pizza popup.",
  excerpt:
    "As part of the pre-season on Pag, D10 welcomes Da Nanni Barcelona, ranked among the 50 Top World Artisan Pizza Chains, for a masterclass and a one-night pizza popup.",
  author: "D10 Editorial",
  role: "Events",
  date: "April 22, 2026",
  readTime: "4 min read",

  datePublished: "2026-04-21",
  dateModified: "2026-04-21",

  heroImage: "/img/articles/2026/da-nanni.jpg",
  image: "/img/articles/2026/da-nanni.jpg",
  author_image: "/logo2.avif",

  tags: ["D10", "Da Nanni", "Pizza", "Masterclass", "Pag", "Events"],

  keyStats: [
    { value: "Apr 28", label: "Event Date" },
    { value: "1", label: "Masterclass" },
    { value: "1 Night", label: "Pizza Popup" },
  ],

  body: [
    {
      type: "paragraph",
      dropcap: true,
      text:
        "Pag is opening its pre-season in the best possible way. D10’s Pizza Fantasista will host colleagues from Da Nanni Barcelona for a special masterclass and a one-night pizza popup, bringing together international experience, technique, and a shared passion for pizza.",
    },

    {
      type: "paragraph",
      text:
        "Barcelona has become one of the key reference points for high-quality pizza and modern Neapolitan cuisine in recent years. Among the standout names in the city is Da Nanni, a family-run pizzeria that has built a strong reputation through consistency, identity, and a clear connection between tradition and a modern urban setting.",
      strong: ["Barcelona", "Da Nanni"],
    },

    {
      type: "paragraph",
      text:
        "Today, Da Nanni is ranked among the 50 Top World Artisan Pizza Chains, holding position #45 on the global list, with multiple locations across Barcelona.",
      strong: ["50 Top World Artisan Pizza Chains"],
      links: [
        {
          text: "50 Top World Artisan Pizza Chains",
          href: "https://www.50toppizza.it/en/referenza/da-nanni-2/",
          external: true,
        },
      ],
    },

    {
      type: "image",
      src: "/img/articles/2026/da-nanni.jpg",
      alt: "Da Nanni Barcelona",
      caption: "Da Nanni Barcelona, ranked among the 50 Top World Artisan Pizza Chains.",
    },

    {
      type: "paragraph",
      text:
        "The concept behind Da Nanni is simple but powerful. A direct connection between Naples and Barcelona, expressed through authentic Italian cuisine and a strong focus on traditional Neapolitan pizza. Over time, it has become a go-to place for locals, while increasingly being recognized by visitors who look for something real.",
    },

    {
      type: "heading",
      text: "Masterclass with Emanuele Archimio",
    },

    {
      type: "paragraph",
      text:
        "The program begins with a professional masterclass led by Emanuele Archimio, focused on Neapolitan pizza techniques. The session is designed for pizzaioli who want to go deeper into dough, fermentation, and execution in a structured, hands-on environment.",
      strong: ["Emanuele Archimio", "Neapolitan pizza"],
    },

    {
      type: "paragraph",
      text:
        "The masterclass will use Molino Piantoni flour, the same flour used by one of the world’s most respected pizza masters, Franco Pepe. This creates a direct link between what is being taught and the highest level of pizza craftsmanship today.",
      strong: ["Molino Piantoni", "Franco Pepe"],
    },

    {
      type: "image",
      src: "/img/articles/2026/pizza masterclass pag emanuele archimio.png",
      alt: "Pizza masterclass",
      caption: "Hands-on masterclass focused on Neapolitan pizza techniques.",
    },

    {
      type: "heading",
      text: "Pizza Popup at D10",
    },

    {
      type: "paragraph",
      text:
        "The day continues with a pizza popup at D10, where the teams take over the kitchen and create a one-night-only menu. The evening will also include instructors from Pag Pizza Academy, adding another layer of knowledge, exchange, and shared experience.",
      strong: ["pizza popup", "one-night-only menu", "Pag Pizza Academy"],
    },

    {
      type: "paragraph",
      text:
        "This format goes beyond a typical event. It creates a space where different approaches, techniques, and backgrounds come together, offering guests not just a meal, but a moment that connects Pag with one of Europe’s most exciting pizza scenes.",
    },


    {
      type: "paragraph",
      text:
        "To make sure you don’t miss it, reservations are now open and can be made through the official D10 website.",
      links: [
        {
          text: "D10 website",
          href: "https://www.d10s.pizza/",
          external: true,
        },
      ],
    },

    {
      type: "paragraph",
      text:
        "Join us for an evening of great food, strong energy, and a unique atmosphere that connects Pag with one of the most dynamic pizza cities in Europe.",
    },
  ],
},
{
  id: 15,
  featured: false,
  slug: "pag-world-class-pizza-masterclass-emanuele-archimio",
  category: "Academy",
  title: "A Day When Pag Became a Meeting Point for World-Class Pizza",
  subtitle:
    "D10’s Pizza Academy hosted a hands-on masterclass with Emanuele Archimio, bringing together pizza enthusiasts, professionals, and pizzeria owners for a full day of dough, technique, ingredients, and Neapolitan tradition.",
  excerpt:
    "For one special day, Pag became a meeting point for pizza enthusiasts and professionals as D10’s Pizza Academy hosted a masterclass with Emanuele Archimio, in collaboration with Molino Piantoni and supported by Mia Familia.",
  author: "D10 Editorial",
  role: "Academy",
  date: "April 29, 2026",
  readTime: "4 min read",

  datePublished: "2026-04-29",
  dateModified: "2026-04-29",

  heroImage: "/img/articles/2026/pizza-academy/dananni.png",
  image: "/img/articles/2026/pizza-academy/dananni.png",
  author_image: "/logo2.avif",

  tags: [
    "D10’s Pizza Academy",
    "Emanuele Archimio",
    "Molino Piantoni",
    "Mia Familia",
    "Neapolitan Pizza",
    "Pag"
  ],

  keyStats: [
    { value: "1", label: "Masterclass" },
    { value: "1 Day", label: "Pizza Experience" },
    { value: "Pag", label: "Pizza Meeting Point" },
  ],

  body: [
    {
      type: "paragraph",
      dropcap: true,
      text:
        "For one unforgettable day, the island of Pag became a meeting point for pizza enthusiasts, professionals, and lovers of authentic Neapolitan tradition through the experience of D10’s Pizza Academy.",
      strong: ["Pag", "D10’s Pizza Academy", "authentic Neapolitan tradition"],
    },

    {
      type: "paragraph",
      text:
        "Hosted in collaboration with Molino Piantoni and supported by Mia Familia, the masterclass brought together participants ranging from curious pizza enthusiasts to experienced pizzaioli and pizzeria owners.",
      strong: ["Molino Piantoni", "Mia Familia", "pizzaioli", "pizzeria owners"],
      links: [
        {
          text: "Molino Piantoni",
          href: "https://www.molinopiantoni.it/en/",
          external: true,
        },
      ],
    },

    {
      type: "paragraph",
      text:
        "The goal was not only to show how pizza is made, but to go deeper into the decisions behind it: how flour behaves, how fermentation changes the dough, how ingredients affect the final result, and why discipline matters in every step of the process.",
      strong: ["flour", "fermentation", "ingredients", "discipline"],
    },

    {
      type: "image",
      src: "/img/articles/2026/pizza-academy/pizza-workshop.jpeg",
      alt: "Emanuele Archimio masterclass at D10’s Pizza Academy",
      caption: "Masterclass with Emanuele Archimio at D10’s Pizza Academy.",
    },

    {
      type: "heading",
      text: "Learning from Emanuele Archimio",
    },

    {
      type: "paragraph",
      text:
        "Under the guidance of renowned pizzaiolo Emanuele Archimio, participants worked through the fundamentals of fermentation, dough management, flour selection, and the use of premium ingredients.",
      strong: ["Emanuele Archimio", "fermentation", "dough management", "flour selection", "premium ingredients"],
    },

    {
      type: "paragraph",
      text:
        "The workshop was built around technical precision, but also around the philosophy behind authentic Neapolitan pizza: respect for tradition, consistency, patience, and the ability to repeat quality under real conditions.",
      strong: ["technical precision", "authentic Neapolitan pizza", "respect for tradition", "consistency"],
    },

    {
      type: "image",
      src: "/img/articles/2026/pizza-academy/pizza-team.jpeg",
      alt: "Participants during the pizza masterclass",
      caption: "Participants explored dough preparation, fermentation, and handling techniques.",
    },

    {
      type: "heading",
      text: "From Flour to Final Result",
    },

    {
      type: "paragraph",
      text:
        "Throughout the day, attendees worked with Molino Piantoni flours and gained a clearer understanding of how fermentation, hydration, handling, and ingredient quality directly shape the final pizza.",
      strong: ["Molino Piantoni flours", "fermentation", "hydration", "ingredient quality"],
    },

    {
      type: "paragraph",
      text:
        "The hands-on approach allowed participants to follow every stage of the process firsthand, from dough preparation and handling to baking, tasting, and understanding the small details that separate a good pizza from a truly precise one.",
      strong: ["hands-on approach", "dough preparation", "baking", "small details"],
    },

    {
      type: "image",
      src: "/img/articles/2026/pizza-academy/pizza-team2.jpeg",
      alt: "Pizza Academy team during the masterclass",
      caption: "A full day of practical work, shared knowledge, and pizza craft.",
    },

    {
      type: "heading",
      text: "Building Pizza Culture on Pag",
    },

    {
      type: "paragraph",
      text:
        "D10’s Pizza Academy continues to grow as a unique educational platform in Croatia, bringing international experts and pizza professionals to the island to share knowledge and raise the level of pizza culture on Pag.",
      strong: ["D10’s Pizza Academy", "educational platform", "Croatia", "Pag"],
    },

    {
      type: "paragraph",
      text:
        "Events like this show how education, hospitality, and local identity can come together in a way that gives Pag a different kind of energy beyond the usual season.",
      strong: ["education", "hospitality", "local identity", "Pag"],
    },

    {
      type: "heading",
      text: "Evening Pizza Popup",
    },

    {
      type: "paragraph",
      text:
        "The highlight of the event was the evening pizza popup signed by Emanuele Archimio. It was the moment where everything explored during the workshop moved from technique into experience.",
      strong: ["pizza popup", "Emanuele Archimio", "technique", "experience"],
    },

    {
      type: "paragraph",
      text:
        "Guests enjoyed authentic flavors, precise execution, and the atmosphere of a community brought together by a shared love for pizza.",
      strong: ["authentic flavors", "precise execution", "shared love for pizza"],
    },

    {
      type: "image",
      src: "/img/articles/2026/pizza-academy/pizza-team3.png",
      alt: "Pizza popup at D10",
      caption: "Pizza popup signed by Emanuele Archimio.",
    },

    {
      type: "heading",
      text: "Thank You",
    },

    {
      type: "paragraph",
      text:
        "A heartfelt thank you goes to everyone who participated and helped make this event special. We are proud to continue building a place where education, tradition, and passion come together.",
      strong: ["education", "tradition", "passion"],
    },

    {
      type: "paragraph",
      text:
        "See you at the next gathering at the official D10’s Pizza Academy page.",
      links: [
        {
          text: "D10’s Pizza Academy",
          href: "https://d10s.pizza/academy/",
          external: true,
        },
      ],
      strong: ["D10’s Pizza Academy"],
    },
  ],
},
{
  id: 16,
  featured: false,
  slug: "d10s-pizza-fantasista-joins-pag-on-the-menu",
  category: "Kitchen",
  title: "D10’s Pizza Fantasista Joins Pag on the Menu",
  subtitle:
    "D10’s Pizza Fantasista joins the Pag on the Menu program with Kaloka Vege, a new pizza that brings together Neapolitan dough, island ingredients, and the recognizable flavors of Pag.",
  excerpt:
    "D10’s Pizza Fantasista is now part of Pag on the Menu, introducing Kaloka Vege as a new signature pizza inspired by Pag cheese, skuta, rosemary, olive oil, and the island’s culinary identity.",
  author: "D10 Editorial",
  role: "Kitchen",
  date: "May 09, 2026",
  readTime: "3 min read",

  datePublished: "2026-05-09",
  dateModified: "2026-05-09",

  heroImage: "/img/articles/2026/pag-on-the-menu/kaloka-pizza.jpeg",
  image: "/img/articles/2026/pag-on-the-menu/kaloka-pizza.jpeg",
  author_image: "/logo2.avif",

  tags: [
    "D10’s Pizza Fantasista",
    "Pag on the Menu",
    "Kaloka Vege",
    "Paški Sir",
    "Pag",
    "Local Food"
  ],

  keyStats: [
    { value: "May 2026", label: "Joined Program" },
    { value: "1", label: "Signature Pizza" },
    { value: "Pag", label: "Local Inspiration" },
  ],

  body: [
    {
      type: "paragraph",
      dropcap: true,
      text:
        "D10’s Pizza Fantasista is now officially part of Pag on the Menu, a local certification program created to highlight restaurants, dishes, and food experiences that carry the ingredients, traditions, and character of the island.",
      strong: ["D10’s Pizza Fantasista", "Pag on the Menu"],
      links: [
        {
          text: "Pag on the Menu",
          href: "https://pagnameniju.com/",
          external: true,
        },
      ],
    },

    {
      type: "paragraph",
      text:
        "For D10, this is not just a label on the menu. It is a natural next step for a pizzeria that was built on the meeting point between Neapolitan pizza culture and the flavors of Pag.",
      strong: ["D10", "Neapolitan pizza culture", "flavors of Pag"],
    },

    {
      type: "paragraph",
      text:
        "From the first day on Prosika, the idea was to make pizza with proper technique, strong ingredients, and a clear connection to the place where it is served. Joining Pag on the Menu confirms that direction in a simple and meaningful way.",
      strong: ["Prosika", "proper technique", "strong ingredients", "Joining Pag on the Menu"],
    },

    {
      type: "image",
      src: "/img/articles/2026/pag-on-the-menu/pagnamenu.jpeg",
      alt: "Pag on the Menu certification at D10’s Pizza Fantasista",
      caption: "D10’s Pizza Fantasista is now part of the Pag on the Menu program.",
    },

    {
      type: "heading",
      text: "Introducing Kaloka Vege",
    },

    {
      type: "paragraph",
      text:
        "To mark this moment, D10 created Kaloka Vege, a new vegetarian signature pizza inspired by the island and shaped through the language of Neapolitan pizza.",
      strong: ["Kaloka Vege", "vegetarian signature pizza", "Neapolitan pizza"],
    },

    {
      type: "paragraph",
      text:
        "The base starts with San Marzano DOP tomatoes, giving the pizza its classic southern Italian foundation. On top of that, Kaloka Vege brings in famous Pag cheese, creamy skuta, rosemary, garlic, and extra virgin olive oil.",
      strong: ["San Marzano DOP tomatoes", "Pag cheese", "skuta", "rosemary", "garlic", "extra virgin olive oil"],
    },

    {
      type: "paragraph",
      text:
        "The result is not a heavy or overcomplicated pizza. It is built around a few ingredients that make sense together: tomato for freshness, Paški sir for depth, skuta for softness, and rosemary with olive oil for that familiar Mediterranean finish.",
      strong: ["Paški sir", "skuta", "rosemary", "olive oil"],
    },

    {
      type: "image",
      src: "/img/articles/2026/pag-on-the-menu/kaloka-pizza.jpeg",
      alt: "Kaloka Vege pizza at D10’s Pizza Fantasista",
      caption: "Kaloka Vege, a new D10 signature pizza inspired by Pag.",
    },

    {
      type: "heading",
      text: "A Pizza That Belongs to the Island",
    },

    {
      type: "paragraph",
      text:
        "Kaloka Vege is our way of showing that local food does not have to stay locked inside traditional formats. The same ingredients that define Pag can also live on a Neapolitan-style pizza, without losing their identity.",
      strong: ["Kaloka Vege", "local food", "Pag", "Neapolitan-style pizza"],
    },

    {
      type: "paragraph",
      text:
        "Pag has a very specific taste. Salt, stone, wind, herbs, cheese, and the sea all shape the island’s food culture. With this pizza, we wanted to turn that feeling into something simple, direct, and easy to understand from the first bite.",
      strong: ["salt", "stone", "wind", "herbs", "cheese", "sea"],
    },

    {
      type: "image",
      src: "/img/articles/2026/pag-on-the-menu/paski-list.jpeg",
      alt: "Paški list feature about Pag on the Menu",
      caption: "Pag on the Menu connects local gastronomy, tourism, and island identity.",
    },

    {
      type: "heading",
      text: "Visit Us This Season",
    },

    {
      type: "paragraph",
      text:
        "Whether you live on Pag or are visiting the island this season, Kaloka Vege is now part of the menu at D10’s Pizza Fantasista on Prosika.",
      strong: ["Pag", "Kaloka Vege", "D10’s Pizza Fantasista", "Prosika"],
    },

    {
      type: "paragraph",
      text:
        "Come try a pizza that connects Neapolitan tradition with the flavors of the Island of Pag.",
      links: [
        {
          text: "Island of Pag",
          href: "https://tzgpag.hr/hr/",
          external: true,
        },
      ],
      strong: ["Neapolitan tradition", "flavors of the Island of Pag"],
    },

    {
      type: "image",
      src: "/img/articles/2026/pag-on-the-menu/timelapse.png",
      alt: "D10’s Pizza Fantasista on Prosika",
      caption: "D10’s Pizza Fantasista on Prosika, where Pag meets pizza.",
    },
  ],
},
{
  id: 17,
  featured: false,
  slug: "pag-pizza-academy-next-intensive-training",
  category: "Academy",
  title: "Applications Open For Pag Pizza Academy",
  subtitle:
    "After the first Academy crew moved straight into professional kitchens, the next six-day intensive training opens the door for a new group ready to learn through dough, fire, discipline, and real kitchen work.",
  excerpt:
    "Pag Pizza Academy is opening applications for the next intensive training, a six-day hands-on program focused on real technique, premium ingredients, and the rhythm of professional pizza kitchens.",
  author: "D10 Editorial",
  role: "Academy",
  date: "May 10, 2026",
  readTime: "4 min read",

  datePublished: "2026-05-10",
  dateModified: "2026-05-10",

  heroImage: "/img/articles/2026/pizza-academy/pizza-academy-workshop1.jpeg",
  image: "/img/articles/2026/pizza-academy/pizza-academy-workshop1.jpeg",
  author_image: "/logo2.avif",

  tags: [
    "Pag Pizza Academy",
    "Pizza Training",
    "D10",
    "Pizzaiolo",
    "Pag",
    "Pizza Education"
  ],

  keyStats: [
    { value: "6", label: "Training Days" },
    { value: "100%", label: "Hands-On Work" },
    { value: "Limited", label: "Available Spots" },
  ],

  body: [
    {
      type: "paragraph",
      dropcap: true,
      text:
        "The next Pag Pizza Academy training is now open for applications. After the first group completed the program and continued directly into professional kitchens, a new crew will soon take their place by the oven.",
      strong: ["Pag Pizza Academy", "professional kitchens", "new crew"],
    },

    {
      type: "paragraph",
      text:
        "This is not a course built around long lectures or empty certificates. It is a six-day practical program where pizza is learned through dough, heat, repetition, timing, and real kitchen rhythm.",
      strong: ["six-day practical program", "dough", "heat", "real kitchen rhythm"],
    },

    {
      type: "paragraph",
      text:
        "From the first day, participants work with their hands. Flour on the table, dough in motion, ovens running, and instructors close enough to correct the details that usually make the biggest difference.",
      strong: ["participants work with their hands", "instructors", "details"],
    },

    {
      type: "image",
      src: "/img/articles/2026/pizza-academy/pizza-academy-workshop1.jpeg",
      alt: "Pag Pizza Academy intensive training",
      caption: "Pag Pizza Academy training is built around hands-on work from day one.",
    },

    {
      type: "heading",
      text: "Six Days of Focused Work",
    },

    {
      type: "paragraph",
      text:
        "The program is built as a six-day intensive training focused on dough preparation, fermentation, ingredient selection, oven technique, timing, workflow, and consistency.",
      strong: ["six-day intensive training", "fermentation", "oven technique", "consistency"],
    },

    {
      type: "paragraph",
      text:
        "The goal is to bring participants closer to the reality of professional pizza work. That means learning how to repeat quality, stay organized, move with purpose, and keep control when the oven is hot and service starts moving.",
      strong: ["professional pizza work", "repeat quality", "stay organized"],
    },

    {
      type: "image",
      src: "/img/articles/2026/pizza-academy/pizza-academy-workshop2.png",
      alt: "Working with dough at Pag Pizza Academy",
      caption: "Participants go through the full process, from dough preparation to baking.",
    },

    {
      type: "heading",
      text: "Pag, Naples, and Real Ingredients",
    },

    {
      type: "paragraph",
      text:
        "Pag Pizza Academy connects the energy of Naples with the character of the island of Pag. The program brings together Neapolitan pizza technique, selected Italian ingredients, local island flavors, and the discipline of real kitchen practice.",
      strong: ["Naples", "Pag", "Neapolitan pizza technique", "local island flavors"],
    },

    {
      type: "paragraph",
      text:
        "Participants work with premium ingredients, from San Marzano tomatoes to selected Italian flours, while also learning how products such as Pag cheese can give pizza a stronger sense of place.",
      strong: ["San Marzano tomatoes", "Italian flours", "Pag cheese"],
    },

    {
      type: "image",
      src: "/img/articles/2026/pizza-academy/pizza-academy-workshop3.jpeg",
      alt: "Pizza ingredients and preparation at Pag Pizza Academy",
      caption: "Premium ingredients are part of the learning process, not just the final result.",
    },

    {
      type: "heading",
      text: "Skills That Stay With You",
    },

    {
      type: "paragraph",
      text:
        "The Academy is not only about making one good pizza during the course. The real goal is to help participants become useful, reliable, and confident inside a working kitchen.",
      strong: ["useful", "reliable", "confident", "working kitchen"],
    },

    {
      type: "paragraph",
      text:
        "That is why the program focuses on skills that matter after the training ends: dough control, consistency, oven work, station discipline, communication, timing, and the ability to deliver quality under pressure.",
      strong: ["dough control", "consistency", "oven work", "quality under pressure"],
    },

    {
      type: "paragraph",
      text:
        "The first participants showed what this approach can do. They did not finish the course and wait for the next step. They moved directly into professional kitchens and continued building from there.",
      strong: ["first participants", "professional kitchens"],
    },

    {
      type: "image",
      src: "/img/articles/2026/pizza-academy/pizza-academy-workshop4.png",
      alt: "Pag Pizza Academy participants during training",
      caption: "The program is practical, intense, and focused on real kitchen readiness.",
    },

    {
      type: "heading",
      text: "Who This Is For",
    },

    {
      type: "paragraph",
      text:
        "This training is made for people who want more than a casual workshop. It is for future pizzaioli, kitchen workers, pizza enthusiasts who want to go deeper, and anyone ready to take the craft seriously.",
      strong: ["future pizzaioli", "kitchen workers", "pizza enthusiasts"],
    },

    {
      type: "paragraph",
      text:
        "You do not need to know everything before you arrive. But you do need energy, focus, curiosity, and the willingness to work. The Academy gives direct attention to every participant, which is why places are limited.",
      strong: ["energy", "focus", "curiosity", "places are limited"],
    },

    {
      type: "image",
      src: "/img/articles/2026/pizza-academy/pizza-academy-workshop5.png",
      alt: "Pag Pizza Academy hands-on workshop",
      caption: "Small groups allow the Academy team to give direct attention to every participant.",
    },

    {
      type: "heading",
      text: "Applications Are Open",
    },

    {
      type: "paragraph",
      text:
        "This is your entry into a world where hard work, patience, and passion still matter. Six days, one island, real ingredients, roaring ovens, and a clear goal: to leave better than you arrived.",
      strong: ["Six days", "one island", "roaring ovens"],
    },

    {
      type: "paragraph",
      text:
        "Applications for the next Pag Pizza Academy training are now open through the official Pag Pizza Academy page. Places are limited because the program is built around direct work, individual guidance, and full attention to every participant.",
      links: [
        {
          text: "Pag Pizza Academy",
          href: "https://d10s.pizza/academy/",
          external: true,
        },
      ],
      strong: ["Applications", "Pag Pizza Academy", "places are limited", "individual guidance"],
    },

    {
      type: "paragraph",
      text:
        "Join the next crew and take your place by the oven.",
      strong: ["Join the next crew"],
    },
  ],
},
{
  id: 18,
  featured: false,
  slug: "jedrzej-lewandowski-confirms-supervision-for-pag-pizza-academy",
  category: "Academy",
  title: "Jędrzej Lewandowski Confirms Supervision for Upcoming Academy Date",
  subtitle:
    "The owner of Zielona Górka, listed among the 50 Top Pizza names, joins the next Pag Pizza Academy training as supervisor and guest star alongside instructors Mario Markušić and Adrian Fetahu.",
  excerpt:
    "From May 18 to 23, Pag Pizza Academy will host its next intensive training with Mario Markušić, Adrian Fetahu, and special guest supervisor Jędrzej Lewandowski from Zielona Górka.",
  author: "D10 Editorial",
  role: "Academy",
  date: "May 11, 2026",
  readTime: "4 min read",

  datePublished: "2026-05-11",
  dateModified: "2026-05-11",

  heroImage: "/img/articles/2026/pizza-academy/jedrzej-lewandowski.jpeg",
  image: "/img/articles/2026/pizza-academy/jedrzej-lewandowski.jpeg",
  author_image: "/logo2.avif",

  tags: [
    "Pag Pizza Academy",
    "Jędrzej Lewandowski",
    "Zielona Górka",
    "50 Top Pizza",
    "Mario Markušić",
    "Adrian Fetahu",
    "Pizza Training",
    "Pag"
  ],

  keyStats: [
    { value: "May 18–23", label: "Training Dates" },
    { value: "50 Top", label: "Pizza Recognition" },
    { value: "1", label: "Guest Supervisor" },
  ],

  body: [
    {
      type: "paragraph",
      dropcap: true,
      text:
        "Pag Pizza Academy is preparing for its next intensive training from May 18 to 23, and this edition brings a special name to the island: Jędrzej Lewandowski, the owner and driving force behind Zielona Górka in Poland.",
      strong: ["Pag Pizza Academy", "May 18 to 23", "Jędrzej Lewandowski", "Zielona Górka"],
    },

    {
      type: "paragraph",
      text:
        "Jędrzej is coming to Pag in the role of supervisor and guest star, adding another layer of international experience, precision, and energy to the Academy program.",
      strong: ["supervisor", "guest star", "international experience"],
    },

    {
      type: "paragraph",
      text:
        "This is exactly the direction behind Pag Pizza Academy: to bring serious pizza knowledge to the island, connect participants with people who work at a high international level, and create a training environment that feels close to a real professional kitchen.",
      strong: ["serious pizza knowledge", "international level", "professional kitchen"],
    },

    {
      type: "image",
      src: "/img/articles/2026/pizza-academy/jedrzej-lewandowski.jpeg",
      alt: "Jędrzej Lewandowski at Pag Pizza Academy",
      caption: "Jędrzej Lewandowski joins Pag Pizza Academy as supervisor and guest star.",
    },

    {
      type: "heading",
      text: "Meet Jędrzej Lewandowski",
    },

    {
      type: "paragraph",
      text:
        "Jędrzej Lewandowski is not the kind of pizza professional who needs a loud introduction. His story is built through years of work, consistency, and a very clear idea of what a pizzeria can become when technique, identity, and hospitality move in the same direction.",
      strong: ["Jędrzej Lewandowski", "technique", "identity", "hospitality"],
    },

    {
      type: "paragraph",
      text:
        "Through Zielona Górka, he helped create one of Poland’s most recognized pizza destinations, a pizzeria listed by 50 Top Pizza and respected far beyond its local market.",
      strong: ["Zielona Górka", "Poland", "50 Top Pizza"],
      links: [
        {
          text: "50 Top Pizza",
          href: "https://www.50toppizza.it/referenza/zielona-gorka-3/",
          external: true,
        },
      ],
    },

    {
      type: "paragraph",
      text:
        "What makes his arrival in Pag important is not only the name, but the mindset he brings with him. Jędrzej understands pizza as a complete system: dough, ingredients, oven work, team rhythm, guest experience, and the small decisions that separate a good pizzeria from a memorable one.",
      strong: ["complete system", "dough", "ingredients", "team rhythm", "guest experience"],
    },

    {
      type: "heading",
      text: "A Supervisor, Not Just a Guest",
    },

    {
      type: "paragraph",
      text:
        "During the May training, Jędrzej will be present as a supervisor and guest star, helping participants understand the standards behind serious pizza work and bringing an outside professional perspective to the Academy.",
      strong: ["May training", "supervisor", "guest star", "professional perspective"],
    },

    {
      type: "paragraph",
      text:
        "His role is to raise the level of the experience. Not by turning the course into a show, but by helping participants see what professional consistency looks like when it is practiced every day.",
      strong: ["raise the level", "professional consistency"],
    },

    {
      type: "image",
      src: "/img/articles/2026/pizza-academy/jedrzej-pag-academy.jpeg",
      alt: "Jędrzej Lewandowski pizza academy supervisor",
      caption: "The next Academy training brings international supervision and practical learning to Pag.",
    },

    {
      type: "heading",
      text: "The Instructor Team",
    },

    {
      type: "paragraph",
      text:
        "Alongside Jędrzej, the training will be led by Mario Markušić and Adrian Fetahu, two instructors who have already played an important role in shaping the Academy’s first programs.",
      strong: ["Mario Markušić", "Adrian Fetahu", "Academy"],
    },

    {
      type: "paragraph",
      text:
        "Mario Markušić brings the precision, discipline, and experience of working at the highest level of Croatian pizza. His role is to guide participants through the details that matter: dough structure, fermentation, baking, consistency, and professional standards.",
      strong: ["Mario Markušić", "precision", "fermentation", "consistency"],
    },

    {
      type: "paragraph",
      text:
        "Adrian Fetahu brings years of practical kitchen experience, calm guidance, and a strong understanding of how to turn technique into daily workflow. His strength is helping participants connect what they learn with the rhythm of real service.",
      strong: ["Adrian Fetahu", "practical kitchen experience", "daily workflow", "real service"],
    },

    {
      type: "image",
      src: "/img/articles/2026/pizza-academy/mario-adrian-academy.jpeg",
      alt: "Mario Markušić and Adrian Fetahu at Pag Pizza Academy",
      caption: "Mario Markušić and Adrian Fetahu return as instructors for the next Academy training.",
    },

    {
      type: "heading",
      text: "Six Days on Pag",
    },

    {
      type: "paragraph",
      text:
        "The next intensive training takes place from May 18 to 23 at Pag Pizza Academy. Over six days, participants will work through dough preparation, fermentation, flour selection, ingredient use, oven technique, station discipline, timing, and kitchen workflow.",
      strong: ["May 18 to 23", "six days", "dough preparation", "fermentation", "kitchen workflow"],
    },

    {
      type: "paragraph",
      text:
        "The format is practical from the beginning. Participants do not only listen and watch. They work, repeat, correct, bake, taste, and learn how small decisions change the final result.",
      strong: ["work", "repeat", "correct", "bake", "taste"],
    },

    {
      type: "paragraph",
      text:
        "This is where the Academy wants to be different. The goal is not to create another nice food workshop, but a serious training experience that helps people understand what pizza work really looks like.",
      strong: ["serious training experience", "pizza work"],
    },

    {
      type: "heading",
      text: "Applications Are Open",
    },

    {
      type: "paragraph",
      text:
        "Applications for the May 18 to 23 Pag Pizza Academy training are now open through the official Pag Pizza Academy page. Places are limited because the program is built around small groups, direct work, and individual guidance.",
      links: [
        {
          text: "Pag Pizza Academy",
          href: "https://d10s.pizza/academy/",
          external: true,
        },
      ],
      strong: ["Applications", "May 18 to 23", "Pag Pizza Academy", "places are limited"],
    },

    {
      type: "paragraph",
      text:
        "For everyone ready to take pizza seriously, this is the moment to join the next crew on Pag.",
      strong: ["take pizza seriously", "next crew", "Pag"],
    },
  ],
},
{
  id: 19,
  featured: false,
  slug: "pag-mayor-becomes-a-certified-pizzaiolo",
  category: "Academy",
  title: "Pag’s Mayor Becomes a Certified Pizzaiolo",
  subtitle:
    "The second cycle of Pag Pizza Academy brought together local students, international mentorship, hands-on training, and a symbolic moment as the mayor of Pag joined the workshop for a day.",
  excerpt:
    "During the second cycle of Pag Pizza Academy, students from Bartul Kašić High School joined a masterclass, the mayor of Pag took part in the training, and three new female pizzaiolas completed the program and will continue working on the island.",
  author: "D10 Editorial",
  role: "Academy",
  date: "May 25, 2026",
  readTime: "4 min read",

  datePublished: "2026-05-25",
  dateModified: "2026-05-25",

  heroImage: "/img/articles/2026/pizza-academy/martinapernar-lewandowski-stipezunic.jpeg",
  image: "/img/articles/2026/pizza-academy/martinapernar-lewandowski-stipezunic.jpeg",
  author_image: "/logo2.avif",

  tags: [
    "Pag Pizza Academy",
    "D10’s Pizza Fantasista",
    "AVPN",
    "Pag",
    "Pizza Education",
    "Bartul Kašić High School"
  ],

  keyStats: [
    { value: "3", label: "New Pizzaiolas" },
    { value: "1", label: "School Masterclass" },
    { value: "1", label: "International Mentor" },
  ],

  body: [
    {
      type: "paragraph",
      dropcap: true,
      text:
        "The second cycle of Pag Pizza Academy brought a different kind of energy to D10’s Pizza Fantasista. It was still about dough, fermentation, technique, oven work, and all the small details that decide whether a pizza really works. But this time, the story also became more local.",
      strong: ["Pag Pizza Academy", "D10’s Pizza Fantasista"],
      links: [
        {
          text: "Pag Pizza Academy",
          href: "https://www.d10s.pizza/academy",
          external: true,
        },
        {
          text: "D10’s Pizza Fantasista",
          href: "https://www.d10s.pizza/",
          external: true,
        },
      ],
    },

    {
      type: "paragraph",
      text:
        "Students from Bartul Kašić High School joined a practical masterclass, Pag’s mayor took part in the training for a day, and three new female pizzaiolas completed the program and will continue working on the island.",
      strong: ["Bartul Kašić High School", "Pag’s mayor", "three new female pizzaiolas"],
      links: [
        {
          text: "Pag’s mayor",
          href: "https://www.pag.hr/",
          external: true,
        },
      ],
    },

    {
      type: "paragraph",
      text:
        "For a project built around education, work, and local hospitality, that combination matters. It shows that the academy is not just a place where people learn how to make pizza. It is slowly becoming a platform where skills, community, and the island’s identity meet in a very practical way.",
      strong: ["education", "work", "local hospitality", "skills", "community"],
    },

    {
      type: "image",
      src: "/img/articles/2026/pizza-academy/martinapernar-lewandowski-stipezunic.jpeg",
      alt: "Martina Pernar, Jędrzej Lewandowski and Stipe Zunić at Pag Pizza Academy",
      caption:
        "The second cycle of Pag Pizza Academy connected local support, international mentorship, and hands-on pizza education.",
    },

    {
      type: "heading",
      text: "Local Support, Without the Formal Distance",
    },

    {
      type: "paragraph",
      text:
        "One of the symbolic moments of this cycle was the mayor’s visit. Instead of only stopping by for a formal photo, he joined the process, worked with the instructors, and experienced part of what participants go through during the academy.",
      strong: ["mayor’s visit", "joined the process"],
    },

    {
      type: "paragraph",
      text:
        "That kind of support makes sense for a project like this. Pag Pizza Academy is connected to the local economy in a direct way. It trains people for real kitchens, supports hospitality, creates new career paths, and gives Pag another reason to be talked about outside the main summer season.",
      strong: ["Pag Pizza Academy", "local economy", "real kitchens", "hospitality", "Pag"],
      links: [
        {
          text: "Pag Pizza Academy",
          href: "https://www.d10s.pizza/academy",
          external: true,
        },
      ],
    },

    {
      type: "paragraph",
      text:
        "It also says something about the direction of the island. Good food projects are not only about restaurants. They can become part of education, tourism, employment, and the way a place presents itself to the world.",
      strong: ["education", "tourism", "employment"],
    },

    {
      type: "image",
      src: "/img/articles/2026/pizza-academy/group-kitchen.jpeg",
      alt: "Pag Pizza Academy group in the kitchen",
      caption:
        "The second cycle focused on practical work, repetition, and preparation for real kitchen conditions.",
    },

    {
      type: "heading",
      text: "Students From Bartul Kašić High School Joined the Masterclass",
    },

    {
      type: "paragraph",
      text:
        "A special part of this cycle was the masterclass for students from Bartul Kašić High School in Pag.",
      strong: ["Bartul Kašić High School", "Pag"],
    },

    {
      type: "paragraph",
      text:
        "The idea was not to give students a lecture about hospitality from a distance. They stepped into a real working environment, handled dough, followed the preparation process, and saw how much precision sits behind something that often looks simple from the guest’s side of the table.",
      strong: ["hospitality", "real working environment", "handled dough", "precision"],
    },

    {
      type: "paragraph",
      text:
        "For young people on the island, this kind of experience makes hospitality more concrete. It shows that food can be a skill, a profession, a creative path, and in some cases, a reason to stay connected to the place they come from.",
      strong: ["food", "skill", "profession", "creative path"],
    },

    {
      type: "image",
      src: "/img/articles/2026/pizza-academy/school.jpeg",
      alt: "Bartul Kašić High School students at Pag Pizza Academy",
      caption:
        "Students from Bartul Kašić High School joined a practical pizza masterclass at D10.",
    },

    {
      type: "heading",
      text: "Learning Under Jędrzej Lewandowski",
    },

    {
      type: "paragraph",
      text:
        "The second cycle was held under the supervision of Jędrzej Lewandowski, the owner of Zielona Górka in Poland and one of the respected names in the European pizza scene.",
      strong: ["Jędrzej Lewandowski", "Zielona Górka"],
      links: [
        {
          text: "Jędrzej Lewandowski",
          href: "https://www.zielonagorka.com.pl/",
          external: true,
        },
        {
          text: "Zielona Górka",
          href: "https://www.zielonagorka.com.pl/",
          external: true,
        },
      ],
    },

    {
      type: "paragraph",
      text:
        "Zielona Górka has been featured on the 50 Top Pizza list, and that kind of international reference gives the academy a level of mentorship that is not easy to find in a small island setting.",
      strong: ["Zielona Górka", "50 Top Pizza", "international reference"],
      links: [
        {
          text: "50 Top Pizza",
          href: "https://www.50toppizza.it/referenza/zielona-gorka-2/",
          external: true,
        },
      ],
    },

    {
      type: "paragraph",
      text:
        "What matters most is not only the reputation. It is the way knowledge is transferred. Participants worked through technique in a practical way, with clear feedback, repetition, and a strong focus on what actually happens in professional kitchens.",
      strong: ["knowledge", "technique", "feedback", "professional kitchens"],
    },

    {
      type: "image",
      src: "/img/articles/2026/pizza-academy/kitchen.jpeg",
      alt: "Kitchen training at Pag Pizza Academy",
      caption:
        "Participants worked through dough preparation, technique, and oven work in a real kitchen environment.",
    },

    {
      type: "heading",
      text: "Three New Female Pizzaiolas for Pag",
    },

    {
      type: "paragraph",
      text:
        "The most concrete result of this cycle is that three new female pizzaiolas completed the program and will continue working on Pag.",
      strong: ["three new female pizzaiolas", "Pag"],
    },

    {
      type: "paragraph",
      text:
        "That is where the academy becomes useful in a very real way. It does not end with a certificate or a nice group photo. The goal is to prepare people for real work, help local hospitality businesses, and raise the quality of what guests can experience on the island.",
      strong: ["certificate", "real work", "local hospitality businesses", "quality"],
    },

    {
      type: "paragraph",
      text:
        "For Pag, this is especially important because good hospitality depends on people. Equipment matters, ingredients matter, and location matters, but trained people are the part that turns everything into an experience worth coming back to.",
      strong: ["good hospitality", "trained people"],
    },

    {
      type: "image",
      src: "/img/articles/2026/pizza-academy/participants.jpeg",
      alt: "Participants of the second cycle of Pag Pizza Academy",
      caption:
        "Three new female pizzaiolas completed the program and will continue working on Pag.",
    },

    {
      type: "heading",
      text: "A Different Layer of Pag’s Food Story",
    },

    {
      type: "paragraph",
      text:
        "Pag already has a strong food identity. Cheese, lamb, salt, local ingredients, and the landscape itself are part of the island’s story. Pizza now adds another layer to that identity, especially when it is connected with education, local work, and international knowledge.",
      strong: ["cheese", "lamb", "salt", "pizza", "education", "local work"],
    },

    {
      type: "paragraph",
      text:
        "The second cycle of Pag Pizza Academy showed that clearly. Students learned by doing. The city showed support. International mentors shared knowledge. New pizzaiolas entered local kitchens.",
      strong: ["Pag Pizza Academy", "students", "city", "international mentors", "new pizzaiolas"],
      links: [
        {
          text: "Pag Pizza Academy",
          href: "https://www.d10s.pizza/academy",
          external: true,
        },
        {
          text: "city",
          href: "https://www.pag.hr/",
          external: true,
        },
      ],
    },

    {
      type: "paragraph",
      text:
        "It is still pizza. But on Pag, it is also becoming education, work, community, and one more reason to look at the island outside the usual summer frame.",
      strong: ["pizza", "education", "work", "community", "Pag"],
    },

    {
      type: "paragraph",
      text:
        "You can follow future workshops, events, and academy updates through D10’s Instagram or the official D10 website.",
      strong: ["D10’s Instagram", "official D10 website"],
      links: [
        {
          text: "D10’s Instagram",
          href: "https://www.instagram.com/d10spizza/",
          external: true,
        },
        {
          text: "official D10 website",
          href: "https://www.d10s.pizza/",
          external: true,
        },
      ],
    },
  ],
  
},
{
  id: 20,
  featured: true,
  slug: "pag-pizza-academy-captain-august-september-2026",
  category: "Academy",
  title: "Meet the New Captains of Pag Pizza Academy",
  subtitle:
    "After previous academy cycles produced new working pizzaiolas, local school workshops, and international mentorship, Pag Pizza Academy opens a new Captain program from August 31 to September 5, 2026.",
  excerpt:
    "The next Captain program at Pag Pizza Academy will take place from August 31 to September 5, 2026, with Greg Yurkovich from Pop's Pizza Ljubljana joining as supervisor of the cycle.",
  author: "D10 Editorial",
  role: "Academy",
  date: "August 12, 2026",
  readTime: "4 min read",

  datePublished: "2026-08-12",
  dateModified: "2026-08-12",

  heroImage: "/img/articles/2026/pizza-academy/cover-yurkovich.jpeg",
  image: "/img/articles/2026/pizza-academy/cover-yurkovich.jpeg",
  author_image: "/logo2.avif",

  tags: [
    "Pag Pizza Academy",
    "Captain Program",
    "D10’s Pizza Fantasista",
    "Greg Yurkovich",
    "Pop's Pizza Ljubljana",
    "50 Top Pizza",
    "Pizza Education",
    "Pag"
  ],

  keyStats: [
    { value: "Aug 31–Sep 5", label: "Captain Dates" },
    { value: "6", label: "Training Days" },
    { value: "1", label: "Guest Supervisor" },
  ],

  body: [
    {
      type: "paragraph",
      dropcap: true,
      text:
        "Pag Pizza Academy is opening a new Captain program cycle from August 31 to September 5, 2026. After the first academy cycles showed how practical pizza education can connect people, work, local hospitality, and the island of Pag, the next group will once again step into a full six-day training focused on real kitchen readiness.",
      strong: ["Pag Pizza Academy", "Captain program", "August 31 to September 5, 2026", "six-day training"],
      links: [
        {
          text: "Pag Pizza Academy",
          href: "https://www.d10s.pizza/academy",
          external: true,
        },
      ],
    },

    {
      type: "paragraph",
      text:
        "The Captain program is designed for people who want more than a casual pizza workshop. Participants work through dough preparation, fermentation, shaping, baking, oven work, ingredient use, timing, workflow, and the rhythm of a professional pizzeria.",
      strong: ["Captain program", "dough preparation", "fermentation", "professional pizzeria"],
    },

    {
      type: "paragraph",
      text:
        "Over six days, the goal is not only to make good pizza during the course, but to understand what makes someone useful, confident, and reliable inside a real kitchen.",
      strong: ["six days", "useful", "confident", "reliable", "real kitchen"],
    },

    {
      type: "image",
      src: "/img/articles/2026/pizza-academy/pizza-academy-sep.jpg",
      alt: "Captain program at Pag Pizza Academy",
      caption:
        "The next Captain program takes place from August 31 to September 5, 2026.",
    },

    {
      type: "heading",
      text: "From Previous Cycles to Real Kitchen Experience",
    },

    {
      type: "paragraph",
      text:
        "The previous academy cycles already showed why this approach matters. Participants did not only leave with certificates and group photos. They moved into professional kitchens, continued working, and started building real experience immediately after completing the program.",
      strong: ["previous academy cycles", "professional kitchens", "real experience"],
    },

    {
      type: "paragraph",
      text:
        "One of the strongest results came from the previous cycle, where three new female pizzaiolas completed the academy and continued working on the island. For Pag, this means new skills, new people in local hospitality, and a stronger base for the season ahead.",
      strong: ["three new female pizzaiolas", "Pag", "local hospitality"],
    },

    {
      type: "paragraph",
      text:
        "The academy was built around a simple idea: food education should create real opportunities, especially in places where hospitality depends on trained, motivated, and reliable people.",
      strong: ["food education", "real opportunities", "trained people"],
    },

    {
      type: "image",
      src: "/img/articles/2026/pizza-academy/participants.jpeg",
      alt: "Participants of Pag Pizza Academy",
      caption:
        "Previous academy cycles produced new working pizzaiolas and practical kitchen experience.",
    },

    {
      type: "heading",
      text: "A Program Connected to Pag",
    },

    {
      type: "paragraph",
      text:
        "Pag Pizza Academy has also become more connected to the local community. In the previous cycle, students from Bartul Kašić High School joined a practical masterclass, while Pag’s mayor took part in the training for a day and experienced the academy from inside the process.",
      strong: ["Bartul Kašić High School", "Pag’s mayor", "practical masterclass"],
      links: [
        {
          text: "Bartul Kašić High School",
          href: "https://ss-bkasica-pag.skole.hr/",
          external: true,
        },
        {
          text: "Pag",
          href: "https://www.pag.hr/",
          external: true,
        },
      ],
    },

    {
      type: "paragraph",
      text:
        "Those moments matter because they show how the academy sits directly between education, tourism, work, hospitality, and local identity. Pizza becomes the format, while the bigger story is about skills, people, and what Pag can offer outside the usual summer frame.",
      strong: ["education", "tourism", "work", "hospitality", "local identity"],
    },

    {
      type: "image",
      src: "/img/articles/2026/pizza-academy/school.jpeg",
      alt: "Students at Pag Pizza Academy",
      caption:
        "Students from Bartul Kašić High School joined a practical pizza masterclass at D10.",
    },

    {
      type: "heading",
      text: "International Standards, Island Setting",
    },

    {
      type: "paragraph",
      text:
        "Previous academy work was also shaped by international mentorship. Jędrzej Lewandowski, owner of Zielona Górka in Poland, supervised the second cycle and helped raise the level of the program through practical feedback, professional standards, and a clear understanding of what makes a pizzeria work every day.",
      strong: ["Jędrzej Lewandowski", "Zielona Górka", "international mentorship", "professional standards"],
      links: [
        {
          text: "Zielona Górka",
          href: "https://www.zielonagorka.com.pl/",
          external: true,
        },
        {
          text: "50 Top Pizza",
          href: "https://www.50toppizza.it/referenza/zielona-gorka-2/",
          external: true,
        },
      ],
    },

    {
      type: "paragraph",
      text:
        "For a small academy on an island, supervision like this keeps the training close to real industry standards, while the program stays personal, practical, and focused on each participant.",
      strong: ["industry standards", "personal", "practical", "each participant"],
    },

    {
      type: "image",
      src: "/img/articles/2026/pizza-academy/kitchen.jpeg",
      alt: "Kitchen training at Pag Pizza Academy",
      caption:
        "The academy combines international mentorship with practical work in a real kitchen setting.",
    },

    {
      type: "heading",
      text: "Greg Yurkovich Joins as Supervisor",
    },

    {
      type: "paragraph",
      text:
        "The next Captain cycle will be supervised by Greg Yurkovich from Pop's Pizza in Ljubljana, Slovenia. Pop's Pizza has become one of the most recognizable pizza names in the region, listed by 50 Top Pizza and known for its quality, consistency, and modern approach to pizza culture.",
      strong: ["Greg Yurkovich", "Pop's Pizza", "Ljubljana", "Slovenia", "50 Top Pizza"],
      links: [
        {
          text: "Pop's Pizza",
          href: "https://www.pizza.thepopsplace.com/",
          external: true,
        },
        {
          text: "50 Top Pizza",
          href: "https://www.50toppizza.it/referenza/pops-pizza-2/",
          external: true,
        },
      ],
    },

    {
      type: "paragraph",
      text:
        "Greg brings an outside professional perspective into the training. Participants will not only learn how to make pizza, but also how to think like someone who belongs inside a working pizzeria: organized, focused, consistent, and ready for service.",
      strong: ["professional perspective", "organized", "focused", "consistent", "ready for service"],
    },

    {
      type: "paragraph",
      text:
        "For participants, this means small-group learning, direct feedback, and exposure to standards from one of the region’s strongest pizza scenes.",
      strong: ["small-group learning", "direct feedback", "regional pizza scene"],
    },

    {
      type: "image",
      src: "/img/articles/2026/greg-yurkovich.jpeg",
      alt: "Greg Yurkovich from Pop's Pizza Ljubljana",
      caption:
        "Greg Yurkovich from Pop's Pizza Ljubljana joins the next Captain cycle as supervisor.",
    },

    {
      type: "heading",
      text: "What the Captain Program Covers",
    },

    {
      type: "paragraph",
      text:
        "During the six-day program, participants will work through the full pizza-making process: dough preparation, fermentation, stretching, topping, baking, oven management, ingredient handling, station organization, and service rhythm.",
      strong: ["dough preparation", "fermentation", "baking", "oven management", "service rhythm"],
    },

    {
      type: "paragraph",
      text:
        "The course is built around repetition and correction. Participants work with their hands from the beginning, receive direct feedback, and learn how small decisions affect the final result.",
      strong: ["repetition", "correction", "direct feedback", "small decisions"],
    },

    {
      type: "paragraph",
      text:
        "The Academy also focuses on the mindset behind professional work: showing up prepared, keeping the station clean, communicating with the team, respecting timing, and understanding how consistency separates a good pizza from a reliable pizza operation.",
      strong: ["professional work", "station clean", "communicating", "consistency"],
    },

    {
      type: "image",
      src: "/img/articles/2026/pizza-academy/pizza-academy-workshop2.png",
      alt: "Dough work at Pag Pizza Academy",
      caption:
        "Captain participants work through the full process from dough to oven.",
    },

    {
      type: "heading",
      text: "New Dates and Applications",
    },

    {
      type: "paragraph",
      text:
        "The next Captain program at Pag Pizza Academy will take place from August 31 to September 5, 2026 at D10’s Pizza Fantasista on Prosika in Pag.",
      strong: ["August 31 to September 5, 2026", "D10’s Pizza Fantasista", "Prosika", "Pag"],
      links: [
        {
          text: "D10’s Pizza Fantasista",
          href: "https://www.d10s.pizza/",
          external: true,
        },
      ],
    },

    {
      type: "paragraph",
      text:
        "Places are limited because the program is built around direct work, small groups, individual feedback, and a training rhythm close to real kitchen conditions.",
      strong: ["Places are limited", "small groups", "individual feedback", "real kitchen conditions"],
    },

    {
      type: "paragraph",
      text:
        "Applications are available through the official Pag Pizza Academy page.",
      strong: ["Applications", "Pag Pizza Academy"],
      links: [
        {
          text: "Pag Pizza Academy",
          href: "https://www.d10s.pizza/academy",
          external: true,
        },
      ],
    },

    {
      type: "paragraph",
      text:
        "Six days, one island, a serious kitchen rhythm, and a new chance to learn the craft properly.",
      strong: ["Six days", "one island", "learn the craft properly"],
    },
  ],
},

{
  id: 21,
  featured: false,
  slug: "maciej-gustav-gadomski-top-10-caputo-cup-naples-2026",
  category: "Academy",
  title: "From Pag to Naples: Maciej and Gustav Finish Top 10 at Caputo Cup",
  subtitle:
    "After qualifying through the competition held at D10’s Pizza Fantasista on Pag, young Polish pizzaiolo Maciej Gadomski reached the world stage in Naples — and, together with his younger brother Gustav, placed among the top 10 national teams in the world.",
  excerpt:
    "Maciej and Gustav Gadomski represented Poland at the Caputo Cup in Naples and finished 9th among national teams, continuing a story that began on Pag through D10’s Pizza Fantasista and Pag Pizza Academy.",
  author: "D10 Editorial",
  role: "Academy",
  date: "July 02, 2026",
  readTime: "4 min read",

  datePublished: "2026-07-01",
  dateModified: "2026-07-01",

  heroImage: "/img/articles/2026/pizza-academy/caputo-maciej-gustav1.jpeg",
  image: "/img/articles/2026/pizza-academy/caputo-maciej-gustav1.jpeg",
  author_image: "/logo2.avif",

  tags: [
    "Pag Pizza Academy",
    "D10’s Pizza Fantasista",
    "Caputo Cup",
    "Naples",
    "Maciej Gadomski",
    "Gustav Gadomski",
    "Poland",
    "Pizza Education"
  ],

  keyStats: [
    { value: "9th", label: "World Ranking" },
    { value: "Top 10", label: "National Teams" },
    { value: "2", label: "Brothers on Stage" },
  ],

  body: [
    {
      type: "paragraph",
      dropcap: true,
      text:
        "Some stories start quietly. Last September on Pag, young Polish pizzaiolo Maciej Gadomski earned his place at the prestigious Caputo Cup final in Naples after competing at D10’s Pizza Fantasista during the Mainardi Food & APN Pizza Cup. At the time, it felt like a big moment. Looking back now, it was only the beginning.",
      strong: [
        "Maciej Gadomski",
        "Caputo Cup",
        "Naples",
        "D10’s Pizza Fantasista",
        "Mainardi Food & APN Pizza Cup"
      ],
      links: [
        {
          text: "Caputo Cup",
          href: "https://www.mulinocaputo.it/en/world-pizza-chef-championship/",
          external: true,
        },
      ],
    },

    {
      type: "paragraph",
      text:
        "What happened in Naples was something few people could have predicted. Maciej arrived as the only competitor representing Poland in the national teams category, which meant he needed someone beside him on stage. That is when his younger brother Gustav stepped in.",
      strong: ["Naples", "Poland", "national teams category", "Gustav"],
    },

    {
      type: "image",
      src: "/img/articles/2026/pizza-academy/caputo-maciej-gustav1.jpeg",
      alt: "Maciej and Gustav Gadomski at Caputo Cup in Naples",
      caption: "Maciej and Gustav Gadomski representing Poland at the Caputo Cup in Naples.",
    },

    {
      type: "heading",
      text: "A Brother Steps In",
    },

    {
      type: "paragraph",
      text:
        "Gustav is only 14 years old and originally came to Naples simply to support his brother. Instead, he found himself standing on one of the biggest pizza stages in the world, surrounded by some of the most respected pizzaioli and pizza masters from across the globe.",
      strong: ["14 years old", "Naples", "biggest pizza stages in the world"],
    },

    {
      type: "paragraph",
      text:
        "Both brothers come from the family bistro Little Madza Lubi in Czeczotki, the same place from which Maciej’s journey toward Pag began last year. From there, the story continued through D10’s Pizza Fantasista, Pag Pizza Academy, and finally Naples.",
      strong: [
        "Little Madza Lubi",
        "Czeczotki",
        "Pag",
        "D10’s Pizza Fantasista",
        "Pag Pizza Academy",
        "Naples"
      ],
    },

    {
      type: "heading",
      text: "From Pag Pizza Academy to the World Stage",
    },

    {
      type: "paragraph",
      text:
        "This is the kind of story Pag Pizza Academy was created for. Not only to teach dough, fermentation, oven work, and technique, but to help open real doors for young people who have discipline, curiosity, and love for the craft.",
      strong: [
        "Pag Pizza Academy",
        "dough",
        "fermentation",
        "oven work",
        "technique"
      ],
    },

    {
      type: "paragraph",
      text:
        "Seeing two young pizzaioli connected with Pag step onto the stage in Naples is a quiet but powerful recognition of the academy’s idea. Sometimes education is not only about certificates or courses. Sometimes it is about creating an environment where talent gets noticed, encouraged, and pushed toward the next opportunity.",
      strong: ["Pag", "Naples", "education", "talent"],
    },

    {
      type: "image",
      src: "/img/articles/2026/pizza-academy/caputo-maciej-gustav3.jpeg",
      alt: "Maciej and Gustav on stage in Naples",
      caption: "A young Polish team on one of the biggest pizza stages in the world.",
    },

    {
      type: "heading",
      text: "Top 10 in the World",
    },

    {
      type: "paragraph",
      text:
        "When Maciej and Gustav stepped in front of the jury, the room was full of experienced professionals, world-class pizza makers, and national teams with far more years behind them. But the two brothers showed focus, professionalism, and energy far beyond their age.",
      strong: ["Maciej", "Gustav", "professionalism", "energy"],
    },

    {
      type: "paragraph",
      text:
        "The final result made the story even bigger. Representing Poland, Maciej and Gustav finished 9th among national teams at the Caputo Cup in Naples, placing themselves among the top 10 national pizza teams in the world.",
      strong: [
        "Poland",
        "9th",
        "Caputo Cup",
        "Naples",
        "top 10 national pizza teams in the world"
      ],
      links: [
        {
          text: "Caputo Cup",
          href: "https://www.mulinocaputo.it/en/world-pizza-chef-championship/",
          external: true,
        },
      ],
    },

    {
      type: "paragraph",
      text:
        "And yes, they finished ahead of Italy. For two young pizzaioli, one of them only 14, that is not just a result. That is a proper pizza story.",
      strong: ["ahead of Italy", "14", "pizza story"],
    },

    {
      type: "quote",
      text:
        "A story that started on Pag continued in Naples — and finished among the best national teams in the world.",
    },

    {
      type: "heading",
      text: "Why This Matters",
    },

    {
      type: "paragraph",
      text:
        "For D10 and Pag Pizza Academy, this is not only about one competition result. It is about seeing a real path take shape: a young pizzaiolo comes to Pag, earns a place in Naples, brings his brother into the story, and together they show that talent can come from anywhere when it gets the right chance.",
      strong: [
        "D10",
        "Pag Pizza Academy",
        "Pag",
        "Naples",
        "talent"
      ],
    },

    {
      type: "paragraph",
      text:
        "That is the kind of recognition we are most proud of. Not loud, not forced, but real. Pag was one of the stops on their journey, and we are grateful that a small part of this story started here.",
      strong: ["Pag"],
    },

    {
      type: "paragraph",
      text:
        "Maciej and Gustav, congratulations. Bravo for the result, bravo for the courage, and bravo for showing that the next generation of pizzaioli is already here.",
      strong: ["Maciej", "Gustav", "congratulations", "next generation of pizzaioli"],
    },

    {
      type: "image",
      src: "/img/articles/2026/pizza-academy/caputo-maciej-gustav2.jpeg",
      alt: "Top 10 national team at the Caputo Cup",
      caption: "Instructor Adriand Fetahu and Maciej Gadomski.",
    },
  ],
},
{
  id: 22,
  featured: false,
  slug: "pag-pizza-academy-instructors-the-best-pizza-awards-2026",
  category: "Academy",
  title: "Pag Pizza Academy Instructors Recognized on the Global Pizza Stage",
  subtitle:
    "As The Best Pizza Awards 2026 gathered the global pizza community in Milan, Pag Pizza Academy proudly saw two of its instructors — Mario Markušić and Greg Yurkovich — connected to one of the most respected platforms in contemporary pizza.",
  excerpt:
    "The Best Pizza Awards 2026 celebrated the world’s leading pizza chefs in Milan. For Pag Pizza Academy, the event carried special meaning through instructors Mario Markušić and Greg Yurkovich.",
  author: "D10 Editorial",
  role: "Academy",
  date: "July 02, 2026",
  readTime: "4 min read",

  datePublished: "2026-07-02",
  dateModified: "2026-07-02",

  heroImage: "/img/articles/2026/pizza-academy/aurora-milone-martina-busic.jpeg",
  image: "/img/articles/2026/pizza-academy/aurora-milone-martina-busic.jpeg",
  author_image: "/logo2.avif",

  tags: [
    "Pag Pizza Academy",
    "The Best Pizza Awards",
    "Mario Markušić",
    "Greg Yurkovich",
    "Milan",
    "Pizza Education",
    "Pizza Culture"
  ],

  keyStats: [
    { value: "150", label: "Pizza Chefs Recognized" },
    { value: "39", label: "Countries Represented" },
    { value: "2", label: "Academy Instructors" },
  ],

  body: [
    {
      type: "paragraph",
      dropcap: true,
      text:
        "Milan once again became the center of the global pizza world as The Best Pizza Awards 2026 gathered leading pizza chefs, international journalists, and hospitality professionals for its most ambitious edition so far.",
      strong: ["Milan", "The Best Pizza Awards 2026", "global pizza world"],
      links: [
        {
          text: "The Best Pizza Awards 2026",
          href: "https://www.thebestchefpizza.com/",
          external: true,
        },
      ],
    },

    {
      type: "paragraph",
      text:
        "The event, powered by Molini Pizzuti, welcomed more than 500 guests, including 300 pizza chefs and 200 international journalists, for a night built around the theme of Legacy & Future — celebrating both the people who shaped pizza culture and those who are pushing it forward.",
      strong: ["Molini Pizzuti", "500 guests", "300 pizza chefs", "200 international journalists", "Legacy & Future"],
    },

    {
      type: "image",
      src: "/img/articles/2026/pizza-academy/martina-ivan-d10s.jpeg",
      alt: "D10’s Pizza Academy representatives",
      caption: "D10’s Pizza Academy continues to connect Pag with the international pizza community.",
    },

    {
      type: "heading",
      text: "The Best Pizza Chef 2026",
    },

    {
      type: "paragraph",
      text:
        "The highest recognition of the evening went to Francesco Martucci of I Masanielli in Caserta, who was named The Best Pizza Chef 2026 for the second consecutive year.",
      strong: ["Francesco Martucci", "I Masanielli", "Caserta", "The Best Pizza Chef 2026"],
    },

    {
      type: "paragraph",
      text:
        "The leading three places reflected the strength and depth of the contemporary pizza scene. Roberto Davanzo of Bob Alchimia a Spicchi in Montepaone finished second, while Francesco Capece of Confine in Milan took third place.",
      strong: ["Roberto Davanzo", "Bob Alchimia a Spicchi", "Francesco Capece", "Confine"],
    },

    {
      type: "image",
      src: "/img/articles/2026/pizza-academy/girl-power-pizza.jpeg",
      alt: "The Best Pizza Awards atmosphere",
      caption: "A global night dedicated to pizza culture, creativity, and the next generation of pizza professionals.",
    },

    {
      type: "heading",
      text: "More Than a Ranking",
    },

    {
      type: "paragraph",
      text:
        "What makes The Best Pizza Awards important is not only the ranking itself, but the way it frames pizza as a global craft. The platform highlights chefs across regions, styles, and traditions, giving visibility to people who are pushing pizza forward through technique, identity, creativity, and consistency.",
      strong: ["global craft", "technique", "identity", "creativity", "consistency"],
    },

    {
      type: "paragraph",
      text:
        "Alongside the Top 100, the 2026 edition introduced Ones to Follow, a non-ranked selection of fifty pizza chefs whose work deserves attention beyond the main list. Together, the Top 100 and Ones to Follow represented 150 pizza chefs from 39 countries across five continents.",
      strong: ["Top 100", "Ones to Follow", "150 pizza chefs", "39 countries", "five continents"],
    },

    {
      type: "quote",
      text:
        "For Pag Pizza Academy, this matters because education is strongest when it is connected to the real global movement of the craft.",
    },

    {
      type: "heading",
      text: "A Proud Moment for Pag Pizza Academy",
    },

    {
      type: "paragraph",
      text:
        "For us at Pag Pizza Academy, this year’s edition carried a special meaning. Two of our instructors, Mario Markušić and Greg Yurkovich, were part of the wider recognition around The Best Pizza Awards 2026 — a quiet but important confirmation that the people teaching in Pag are connected to the same conversation as the world’s most respected pizza professionals.",
      strong: ["Pag Pizza Academy", "Mario Markušić", "Greg Yurkovich", "The Best Pizza Awards 2026"],
    },

    {
      type: "paragraph",
      text:
        "Mario Markušić has been one of the key instructors from the beginning of the academy story. His experience, discipline, and understanding of professional pizza work helped shape the standards we want to pass on to every participant who comes to Pag.",
      strong: ["Mario Markušić", "academy story", "professional pizza work", "Pag"],
    },

    {
      type: "image",
      src: "/img/articles/2026/pizza-academy/Mario Markušić & Fran Župić - Franko’s Pizza & Bar - Zagreb - Croatia.jpeg",
      alt: "Mario Markušić and Fran Župić from Franko’s Pizza & Bar Zagreb",
      caption: "Mario Markušić and Fran Župić from Franko’s Pizza & Bar in Zagreb.",
    },

    {
      type: "paragraph",
      text:
        "Greg Yurkovich brings another kind of international perspective: knowledge, structure, and a deep understanding of how pizza culture is developing globally. His work connects education, hospitality, and the wider professional pizza scene in a way that fits naturally with what Pag Pizza Academy wants to become.",
      strong: ["Greg Yurkovich", "international perspective", "pizza culture", "Pag Pizza Academy"],
    },

    {
      type: "image",
      src: "/img/articles/2026/pizza-academy/Greg Yurkovich - Pop_s Pizza  - Ljubljana - Slovenia.jpeg",
      alt: "Greg Yurkovich from Pop’s Pizza Ljubljana",
      caption: "Greg Yurkovich from Pop’s Pizza in Ljubljana.",
    },

    {
      type: "heading",
      text: "Why It Matters for Participants",
    },

    {
      type: "paragraph",
      text:
        "Pag Pizza Academy was created to be more than a local course. The goal is to connect participants with people who understand what is happening at the highest level of pizza today — from dough and fermentation to service, consistency, identity, and career development.",
      strong: ["Pag Pizza Academy", "highest level of pizza", "dough", "fermentation", "career development"],
    },

    {
      type: "paragraph",
      text:
        "When instructors are connected to international platforms such as The Best Pizza Awards, participants are not only learning recipes or isolated techniques. They are learning from people who are part of a broader professional standard and who understand where pizza is going next.",
      strong: ["The Best Pizza Awards", "professional standard", "where pizza is going next"],
    },

    {
      type: "image",
      src: "/img/articles/2026/pizza-academy/aurora-milone-martina-busic.jpeg",
      alt: "Aurora Milone and Martina Bušić",
      caption: "A new generation of pizza professionals connected through international events, education, and shared craft.",
    },

    {
      type: "heading",
      text: "Legacy and Future, From Milan to Pag",
    },

    {
      type: "paragraph",
      text:
        "The theme of this year’s awards — Legacy & Future — fits closely with what we are trying to build on Pag. Pizza is rooted in tradition, but it grows through people who are willing to learn, adapt, travel, teach, and share knowledge.",
      strong: ["Legacy & Future", "Pag", "tradition", "share knowledge"],
    },

    {
      type: "paragraph",
      text:
        "That connection between heritage and progress is exactly what Pag Pizza Academy wants to bring to the island. A place where young pizzaioli, enthusiasts, and professionals can learn the foundations properly, but also understand how pizza is changing around the world.",
      strong: ["heritage", "progress", "Pag Pizza Academy", "young pizzaioli"],
    },

    {
      type: "paragraph",
      text:
        "Seeing our instructors connected to one of the most respected global pizza platforms is a proud moment, but also a responsibility. It reminds us that the level of education we build on Pag has to stay ambitious, practical, and connected to the real world of pizza.",
      strong: ["global pizza platforms", "education", "Pag", "real world of pizza"],
    },

    {
      type: "paragraph",
      text:
        "Congratulations to all chefs recognized at The Best Pizza Awards 2026, and especially to Mario Markušić and Greg Yurkovich. We are proud to have them as part of the Pag Pizza Academy story.",
      strong: ["The Best Pizza Awards 2026", "Mario Markušić", "Greg Yurkovich", "Pag Pizza Academy"],
    },
  ],
},
{
  id: 23,
  featured: true,
  slug: "first-pizza-brand-to-bake-pizza-underwater",
  category: "News",

  title: "Yes, We Baked a Pizza Underwater",

  subtitle:
    "D10 becomes the first pizza brand in the world to prepare and bake its own pizza underwater — because apparently making pizza on dry land was becoming too predictable.",

  excerpt:
    "It was not delivered, reheated, or brought underwater for a photograph. We stretched the dough, added the ingredients, fired the oven, and baked a real D10 pizza while underwater.",

  author: "D10 Editorial",
  role: "News",
  date: "July 11, 2026",
  readTime: "6 min read",

  datePublished: "2026-07-11",
  dateModified: "2026-07-11",

  heroImage: "/img/articles/2026/d10-underwater-pizza.jpeg",
  image: "/img/articles/2026/d10-underwater-pizza.jpeg",
  author_image: "/logo2.avif",

  tags: [
    "D10",
    "Underwater Pizza",
    "World First",
    "Pizza Brand",
    "Pizza Fantasista",
    "Submarine Pizza",
    "Pizza Innovation"
  ],

  keyStats: [
    { value: "1st", label: "Pizza Brand to Do It" },
    { value: "1", label: "Pizza Baked Underwater" },
    { value: "0", label: "Metres of Dry Land Needed" },
  ],

  body: [
    {
      type: "paragraph",
      dropcap: true,
      text:
        "The oven was hot. The dough was ready. Outside the walls, there was water in every direction. And somewhere between the careful preparation, the narrow working space, and the slightly unreasonable nature of the entire idea, we realised something: we were actually about to bake a pizza underwater.",
      strong: [
        "we were actually about to bake a pizza underwater"
      ],
    },

    {
      type: "paragraph",
      text:
        "Not bring a finished pizza underwater. Not deliver one by submarine. Not hold a pizza next to a window, take a photograph, and write an ambitious caption about breaking boundaries.",
      strong: [
        "Not bring a finished pizza underwater",
        "Not deliver one by submarine"
      ],
    },

    {
      type: "paragraph",
      text:
        "We prepared it there. We stretched the dough, added the ingredients, placed it in the oven, and baked a real D10 pizza while the vessel was underwater.",
      strong: [
        "prepared it there",
        "baked a real D10 pizza",
        "underwater"
      ],
    },

    {
      type: "paragraph",
      text:
        "So yes, this is a sentence we can now write: D10 has baked a pizza underwater.",
      strong: [
        "D10 has baked a pizza underwater"
      ],
    },

    {
      type: "image",
      src: "/img/articles/2026/preparing-pizza-underwater.jpeg",
      alt: "D10 preparing and baking pizza underwater",
      caption:
        "Dough, ingredients, an oven, and considerably more water than in our usual kitchen.",
    },

    {
      type: "quote",
      text:
        "A fantasista does not play the obvious pass. Apparently, neither does our oven.",
    },

    {
      type: "heading",
      text: "The First Pizza Brand to Bake Pizza Underwater",
    },

    {
      type: "paragraph",
      text:
        "To the best of our knowledge, D10 is the first pizza brand in the world to prepare and bake its own pizza underwater.",
      strong: [
        "the first pizza brand in the world",
        "prepare and bake its own pizza underwater"
      ],
    },

    {
      type: "paragraph",
      text:
        "The wording matters. We are not claiming that nobody has ever eaten or made pizza inside a submarine. Submarine crews spend long periods below the surface, and their kitchens are far more capable than most people probably imagine.",
    },

    {
      type: "paragraph",
      text:
        "In fact, before the U.S. Navy sends us an official correction, we should acknowledge that its submarine crews have been preparing pizza from scratch underwater for years. They also operate nuclear-powered submarines, so we are perfectly happy to let them keep the broader category.",
      strong: [
        "before the U.S. Navy sends us an official correction",
        "preparing pizza from scratch underwater"
      ],
      links: [
        {
          text: "submarine crews have been preparing pizza from scratch underwater",
          href: "https://www.war.gov/News/Feature-Stories/story/Article/1738808/the-most-exclusive-restaurant-in-the-world/",
          external: true,
        },
      ],
    },

    {
      type: "paragraph",
      text:
        "Our claim is more specific: as far as we can establish, D10 is the first actual pizza brand to take its own dough, ingredients, people, and pizza-making process underwater and bake its pizza there.",
      strong: [
        "the first actual pizza brand",
        "pizza-making process underwater"
      ],
    },

    {
      type: "paragraph",
      text:
        "Unless the U.S. Navy has quietly opened a pizzeria franchise without telling anyone, we think the distinction is fair.",
      strong: [
        "Unless the U.S. Navy has quietly opened a pizzeria franchise"
      ],
    },

    {
      type: "image",
      src: "/img/articles/2026/dough-inside-submarine.JPG",
      alt: "D10 pizza dough being stretched underwater inside a submarine",
      caption:
        "The full process took place underwater, beginning with the dough.",
    },

    {
      type: "heading",
      text: "This Was Not an Underwater Pizza Delivery",
    },

    {
      type: "paragraph",
      text:
        "Pizza has travelled to some interesting places before. It has been delivered by boats, carried into unusual environments, and even sent into space. But bringing a finished pizza somewhere and making one there are two very different things.",
      strong: [
        "bringing a finished pizza somewhere",
        "making one there"
      ],
    },

    {
      type: "paragraph",
      text:
        "For us, the process was the entire point. The pizza could not simply arrive underwater as a passenger. It had to become a pizza underwater.",
      strong: [
        "It had to become a pizza underwater"
      ],
    },

    {
      type: "paragraph",
      text:
        "That meant bringing the real components of D10 into an environment that was never designed to function as a pizzeria: the dough, the ingredients, the equipment, the technique, and the people responsible for putting everything together.",
      strong: [
        "the real components of D10",
        "never designed to function as a pizzeria"
      ],
    },

    {
      type: "paragraph",
      text:
        "The space was tighter. Every movement had to be considered. There was no familiar kitchen rhythm and no room for unnecessary steps. What normally feels natural suddenly required concentration, adaptation, and a very clear understanding of the process.",
      strong: [
        "concentration",
        "adaptation",
        "a very clear understanding of the process"
      ],
    },

    {
      type: "image",
      src: "/img/articles/2026/topping-pizza-underwater.JPG",
      alt: "Adding ingredients to a D10 pizza underwater",
      caption:
        "Every movement mattered inside a workspace built for almost everything except pizza.",
    },

    {
      type: "heading",
      text: "Making Pizza Where Pizza Should Not Work",
    },

    {
      type: "paragraph",
      text:
        "A good pizza depends on control. The dough must be handled correctly. The ingredients need balance. The oven needs heat. Timing matters from the first movement until the final bake.",
      strong: [
        "control",
        "balance",
        "heat",
        "Timing"
      ],
    },

    {
      type: "paragraph",
      text:
        "Underwater, none of those rules disappeared. If anything, they became more important.",
      strong: [
        "they became more important"
      ],
    },

    {
      type: "paragraph",
      text:
        "The environment could be unusual, but the pizza could not become a prop. It still needed to be stretched properly. It still needed to bake correctly. It still needed to look, smell, and taste like something we would be proud to serve.",
      strong: [
        "the pizza could not become a prop",
        "proud to serve"
      ],
    },

    {
      type: "paragraph",
      text:
        "That was the rule from the beginning. The story could be slightly crazy. The pizza still had to be serious.",
      strong: [
        "The story could be slightly crazy",
        "The pizza still had to be serious"
      ],
    },

    {
      type: "quote",
      text:
        "Doing something for the first time is nice. Doing it properly is the part that actually counts.",
    },

    {
      type: "heading",
      text: "Then the Oven Opened",
    },

    {
      type: "paragraph",
      text:
        "There is always a moment when an ambitious idea stops being an idea.",
    },

    {
      type: "paragraph",
      text:
        "For us, it happened when the oven opened.",
      strong: [
        "when the oven opened"
      ],
    },

    {
      type: "paragraph",
      text:
        "Until then, we had equipment, ingredients, plans, and a good story in progress. But none of it meant very much without the final result.",
    },

    {
      type: "paragraph",
      text:
        "The pizza came out baked. The crust had risen. The ingredients had come together. What began as a question had become something we could place in front of people, cut, taste, and finally believe.",
      strong: [
        "The pizza came out baked",
        "cut",
        "taste",
        "believe"
      ],
    },

    {
      type: "paragraph",
      text:
        "It looked like a D10 pizza. It smelled like a D10 pizza. It tasted like a D10 pizza.",
      strong: [
        "looked like a D10 pizza",
        "smelled like a D10 pizza",
        "tasted like a D10 pizza"
      ],
    },

    {
      type: "paragraph",
      text:
        "The only unusual detail was that it had just been prepared and baked underwater.",
      strong: [
        "prepared and baked underwater"
      ],
    },

    {
      type: "image",
      src: "/img/articles/2026/pizza-baking-underwater.JPG",
      alt: "D10 pizza baking underwater",
      caption:
        "The moment the idea became real: a D10 pizza was made underwater.",
    },

    {
      type: "heading",
      text: "Why Did We Do It?",
    },

    {
      type: "paragraph",
      text:
        "There was no urgent global demand for underwater pizza. Nobody had contacted us to report a serious shortage. Our customers were not standing outside asking when the submarine menu would launch.",
      strong: [
        "no urgent global demand for underwater pizza",
        "submarine menu"
      ],
    },

    {
      type: "paragraph",
      text:
        "We did it because D10 has never been interested only in putting ingredients on dough.",
    },

    {
      type: "paragraph",
      text:
        "Pizza is our product, our craft, and the centre of everything we do. But it is also our way of creating experiences, connecting different worlds, and building stories people want to share.",
      strong: [
        "our product",
        "our craft",
        "creating experiences",
        "building stories"
      ],
    },

    {
      type: "paragraph",
      text:
        "That thinking is already part of D10. We connect pizza with football. We use it to bring people together through the Pizza Academy. We invite international pizzaioli to exchange knowledge. We create pizzas inspired by players, places, ingredients, and moments.",
      strong: [
        "pizza with football",
        "Pizza Academy",
        "exchange knowledge"
      ],
    },

    {
      type: "paragraph",
      text:
        "Baking one underwater follows the same logic. Take the craft seriously, then place it inside a story nobody expects.",
      strong: [
        "Take the craft seriously",
        "a story nobody expects"
      ],
    },

    {
      type: "heading",
      text: "A Fantasista Tries the Pass Nobody Else Sees",
    },

    {
      type: "paragraph",
      text:
        "The name Pizza Fantasista was never chosen only because it sounded good.",
    },

    {
      type: "paragraph",
      text:
        "In football, the fantasista is the player who sees something before everyone else. The player who tries the unexpected pass, creates space where there appeared to be none, and turns an ordinary moment into something worth remembering.",
      strong: [
        "sees something before everyone else",
        "tries the unexpected pass",
        "worth remembering"
      ],
    },

    {
      type: "paragraph",
      text:
        "That is how we want D10 to behave as a pizza brand.",
      strong: [
        "how we want D10 to behave"
      ],
    },

    {
      type: "paragraph",
      text:
        "Not different simply for the sake of being different. Not loud without substance. But curious enough to ask unusual questions and serious enough to follow them all the way to a finished result.",
      strong: [
        "curious enough to ask unusual questions",
        "a finished result"
      ],
    },

    {
      type: "paragraph",
      text:
        "Could a pizza brand prepare and bake a real pizza underwater?",
    },

    {
      type: "paragraph",
      text:
        "We now know the answer.",
      strong: [
        "We now know the answer"
      ],
    },

    {
      type: "image",
      src: "/img/articles/2026/finished-underwater-pizza.JPG",
      alt: "Finished D10 pizza prepared and baked underwater",
      caption:
        "A real D10 pizza, prepared and baked underwater from start to finish.",
    },

    {
      type: "heading",
      text: "Yes, We Actually Did It",
    },

    {
      type: "paragraph",
      text:
        "We are not pretending that underwater pizza will transform the global food industry. There is currently no plan to add a submarine drive-through, and reservations for tables below sea level remain unavailable.",
      strong: [
        "no plan to add a submarine drive-through",
        "tables below sea level remain unavailable"
      ],
    },

    {
      type: "paragraph",
      text:
        "But this moment says something important about the type of brand we want to build.",
    },

    {
      type: "paragraph",
      text:
        "You do not need to be the biggest brand to create something nobody has seen before. You need a strong product, people willing to try, and just enough imagination to ignore the sentence: that probably makes no sense.",
      strong: [
        "You do not need to be the biggest brand",
        "something nobody has seen before",
        "that probably makes no sense"
      ],
    },

    {
      type: "paragraph",
      text:
        "We had the dough. We had the oven. We found the water.",
      strong: [
        "We had the dough",
        "We had the oven",
        "We found the water"
      ],
    },

    {
      type: "paragraph",
      text:
        "And now D10 can officially say that it became, to the best of our knowledge, the first pizza brand in the world to prepare and bake its own pizza underwater.",
      strong: [
        "the first pizza brand in the world",
        "prepare and bake its own pizza underwater"
      ],
    },

    {
      type: "quote",
      text:
        "Yes, we did it. The pizza was good. The view was mostly water.",
    },

    {
      type: "heading",
      text: "What Comes After Underwater Pizza?",
    },

    {
      type: "paragraph",
      text:
        "For now, the oven is back above the surface and our everyday work continues.",
    },

    {
      type: "paragraph",
      text:
        "But once you have baked a pizza underwater, the list of ideas that sound completely impossible becomes considerably shorter.",
      strong: [
        "the list of ideas that sound completely impossible becomes considerably shorter"
      ],
    },

    {
      type: "paragraph",
      text:
        "We already know the question everyone will ask next.",
    },

    {
      type: "paragraph",
      text:
        "Where are we baking the next one?",
      strong: [
        "Where are we baking the next one?"
      ],
    },
  ],
},
{
  id: 24,
  featured: false,
  slug: "what-to-eat-in-pag-local-food-guide",
  category: "Guide",

  title: "What to Eat in Pag: 9 Local Foods and Where to Try Them",

  subtitle:
    "A local guide to Paški sir, Pag lamb, seafood, skuta, baškotini, olive oil, island wine and pizza in Pag — including how D10’s Pizza Fantasista brings local ingredients onto carefully made dough.",

  excerpt:
    "Wondering what to eat in Pag or where to eat in Pag? Discover nine essential island flavours, from Paški sir and lamb to seafood, skuta and pizza made with local ingredients at D10’s Pizza Fantasista on Prosika Beach.",

  author: "D10 Editorial",
  role: "Local Pag Food Guide",
  date: "July 11, 2025",
  readTime: "10 min read",

  datePublished: "2025-07-11",
  dateModified: "2025-07-11",

  seo: {
    title: "What to Eat in Pag: Local Food & Pizza | D10",
    description:
      "Discover what to eat in Pag, from Paški sir and lamb to seafood, skuta and pizza made with local ingredients at D10 on Prosika Beach.",
    canonical:
      "https://www.d10s.pizza/blog/what-to-eat-in-pag-local-food-guide/",
    focusKeyword: "what to eat in Pag",
    secondaryKeywords: [
      "where to eat in Pag",
      "pizza in Pag",
      "pizzeria Pag",
      "best pizza in Pag",
      "Pag local food",
      "traditional food Pag",
      "restaurants in Pag",
      "Paški sir pizza"
    ]
  },

  heroImage: "/img/articles/pag-panorama.jpg",
  image: "/img/articles/pag-panorama.jpg",
  author_image: "/logo2.avif",

  tags: [
    "What to Eat in Pag",
    "Where to Eat in Pag",
    "Pizza in Pag",
    "Pizzeria Pag",
    "Pag Local Food",
    "Traditional Food Pag",
    "Paški Sir",
    "Pag Lamb",
    "D10 Pizza Fantasista"
  ],

  keyStats: [
    { value: "9", label: "Essential Pag Flavours" },
    { value: "1", label: "Island Behind Every Dish" },
    { value: "Prosika", label: "D10’s Beachside Home" },
  ],

  body: [
    {
      type: "paragraph",
      dropcap: true,
      text:
        "Wondering what to eat in Pag? Begin with the ingredients that could only taste this way because they come from this island: Paški sir, Pag lamb, fresh seafood, skuta, baškotini, olive oil, local wine and salt. Then leave room for the newer dishes that use those same flavours in a different way.",
      strong: [
        "what to eat in Pag",
        "Paški sir",
        "Pag lamb",
        "fresh seafood",
        "skuta"
      ],
    },

    {
      type: "paragraph",
      text:
        "This is also a guide for anyone deciding where to eat in Pag. The island offers traditional konobas, seafood restaurants, family producers and modern kitchens. At D10’s Pizza Fantasista on Prosika Beach, we work with Pag ingredients every day and see how quickly a meal becomes more memorable when visitors understand the place behind what they are eating.",
      strong: [
        "where to eat in Pag",
        "D10’s Pizza Fantasista",
        "Prosika Beach",
        "Pag ingredients"
      ],
      links: [
        {
          text: "D10’s Pizza Fantasista",
          href: "/"
        }
      ],
    },

    {
      type: "paragraph",
      text:
        "Food on Pag is not separate from the landscape. The bura carries salt across stone and herbs. Sheep graze on that sparse vegetation. The sea supplies the daily catch. Olive trees survive where softer plants would struggle. Those conditions shape the island’s most recognizable flavours.",
      strong: [
        "bura",
        "salt",
        "stone",
        "herbs",
        "sea"
      ],
    },

    {
      type: "quote",
      text:
        "You have not really visited Pag until at least one meal has tasted like the island around you.",
    },

    {
      type: "heading",
      text: "What Food Is Pag Famous For?",
    },

    {
      type: "list",
      tone: "card",
      items: [
        {
          text:
            "Paški sir — the island’s best-known product and the essential first taste of Pag.",
          strong: ["Paški sir"]
        },
        {
          text:
            "Paška janjetina — local lamb shaped by Pag’s rocky terrain, herbs and salt-carrying wind.",
          strong: ["Paška janjetina"]
        },
        {
          text:
            "Fresh Adriatic seafood — grilled fish, octopus, squid and shellfish prepared with restraint.",
          strong: ["Fresh Adriatic seafood"]
        },
        {
          text:
            "Paška skuta — a fresh, soft and delicate dairy product often missed by first-time visitors.",
          strong: ["Paška skuta"]
        },
        {
          text:
            "Paški baškotin — a crisp convent biscuit with more than three centuries of local tradition.",
          strong: ["Paški baškotin"]
        },
        {
          text:
            "Local olive oil — especially oils connected with the ancient olive landscape around Lun.",
          strong: ["Local olive oil"]
        },
        {
          text:
            "Žutica and Gegić — names connected with Pag’s historic wine identity.",
          strong: ["Žutica", "Gegić"]
        },
        {
          text:
            "Pag salt — the ingredient that quietly connects the island’s food, history and landscape.",
          strong: ["Pag salt"]
        },
        {
          text:
            "Pizza with Pag ingredients — a modern way to taste Paški sir, skuta, herbs and olive oil together.",
          strong: ["Pizza with Pag ingredients"]
        }
      ],
    },

    {
      type: "heading",
      text: "1. Paški Sir: The First Thing to Taste in Pag",
    },

    {
      type: "paragraph",
      text:
        "Paški sir is the natural starting point for any guide to traditional food in Pag. It is made from the milk of the indigenous Pag sheep, which graze across sparse, aromatic terrain exposed to the salt carried by the bura wind.",
      strong: [
        "Paški sir",
        "traditional food in Pag",
        "indigenous Pag sheep"
      ],
      links: [
        {
          text: "Paški sir",
          href: "https://croatia.hr/en-gb/food-and-drink/pag-island-cheese",
          external: true
        }
      ],
    },

    {
      type: "paragraph",
      text:
        "Try more than one age. Younger cheese is usually softer and gentler. A more mature wheel becomes firmer, more aromatic and more intense. Tasting them side by side makes it easier to understand why Paški sir is not merely a souvenir but a complete food culture.",
      strong: [
        "Younger cheese",
        "more mature wheel",
        "a complete food culture"
      ],
    },

    {
      type: "paragraph",
      text:
        "Paški sir also works beyond the traditional cheese board. At D10, it gives the Dalma pizza its unmistakably local finish, alongside an olive oil base, arugula, Dalmatian prosciutto and cherry tomatoes.",
      strong: [
        "At D10",
        "Dalma pizza",
        "unmistakably local finish"
      ],
      links: [
        {
          text: "Dalma pizza",
          href: "/menu/dalma/"
        }
      ],
    },

    {
      type: "heading",
      text: "2. Paška Janjetina: The Island Landscape on a Plate",
    },

    {
      type: "paragraph",
      text:
        "Pag lamb cannot be separated from the environment in which it was raised. The sheep move through harsh rocky terrain and feed on sparse vegetation and medicinal herbs touched by sea salt carried through the air.",
      strong: [
        "Pag lamb",
        "harsh rocky terrain",
        "medicinal herbs"
      ],
      links: [
        {
          text: "Pag lamb",
          href: "https://tzgpag.hr/en/vodic/gastronomija/39-pa%C5%A1ka-janjetina.html",
          external: true
        }
      ],
    },

    {
      type: "paragraph",
      text:
        "The best traditional preparations are usually simple: roasted, slowly cooked or prepared under a peka, with uncomplicated sides. This is not a quick snack before returning to the beach. It is the meal around which you build the afternoon.",
      strong: [
        "roasted",
        "slowly cooked",
        "prepared under a peka",
        "the meal around which you build the afternoon"
      ],
    },

    {
      type: "heading",
      text: "3. Fresh Seafood: Ask What Arrived Today",
    },

    {
      type: "paragraph",
      text:
        "Pag is an island, so seafood belongs high on the list. Look for grilled fish, octopus, squid, shellfish or a fisherman’s-style dish built around what was available that day rather than what looked most elaborate on a permanent menu.",
      strong: [
        "grilled fish",
        "octopus",
        "squid",
        "shellfish"
      ],
    },

    {
      type: "paragraph",
      text:
        "The most useful question is often not, “What is your most popular dish?” Ask what is fresh, what arrived recently and what the kitchen would choose. Good seafood may need little more than olive oil, garlic, parsley, fire and Pag salt.",
      strong: [
        "what is fresh",
        "what arrived recently",
        "Pag salt"
      ],
    },

    {
      type: "heading",
      text: "4. Paška Skuta: The Local Ingredient Visitors Nearly Miss",
    },

    {
      type: "paragraph",
      text:
        "Paški sir receives most of the attention. Paška skuta is the quieter discovery. It is made from the whey left during cheese production and is fresh, mild, soft and delicate rather than aged and intense.",
      strong: [
        "Paška skuta",
        "fresh",
        "mild",
        "soft"
      ],
      links: [
        {
          text: "Paška skuta",
          href: "https://welovecheese.club/en/store/sheep-cheese/paska-skuta/",
          external: true
        }
      ],
    },

    {
      type: "paragraph",
      text:
        "Skuta can appear in savoury or sweet combinations: with herbs and olive oil, with honey, inside pastries, beside vegetables or as a softer counterpoint to stronger island flavours. Its availability can be seasonal, so order it when you find it.",
      strong: [
        "savoury or sweet combinations",
        "seasonal"
      ],
    },

    {
      type: "paragraph",
      text:
        "It is also one of the ingredients behind Kaloka Vege, a D10 pizza created around San Marzano tomatoes, Paški sir, skuta, rosemary, garlic and extra virgin olive oil.",
      strong: [
        "Kaloka Vege",
        "Paški sir",
        "skuta",
        "rosemary"
      ],
      links: [
        {
          text: "Kaloka Vege",
          href: "/blog/d10s-pizza-fantasista-joins-pag-on-the-menu/"
        }
      ],
    },

    {
      type: "heading",
      text: "5. Paški Baškotin: A Small Biscuit with a Long Memory",
    },

    {
      type: "paragraph",
      text:
        "Paški baškotin is a hard, sweet toasted biscuit traditionally made by the Benedictine nuns of the Convent of St. Margaret in the town of Pag. Its story has been preserved for more than 300 years.",
      strong: [
        "Paški baškotin",
        "Benedictine nuns",
        "more than 300 years"
      ],
      links: [
        {
          text: "Paški baškotin",
          href: "https://tzgpag.hr/en/vodic/gastronomija/41-ba%C5%A1kotini-izvorno-hrvatsko.html",
          external: true
        }
      ],
    },

    {
      type: "paragraph",
      text:
        "It is modest, crisp and very different from desserts designed mainly for photographs. Buy a packet before leaving Pag. It is one of the few souvenirs likely to disappear before you reach home.",
      strong: [
        "before leaving Pag",
        "disappear before you reach home"
      ],
    },

    {
      type: "heading",
      text: "6. Local Olive Oil: Taste It Before You Pour It",
    },

    {
      type: "paragraph",
      text:
        "Olive oil often arrives automatically at the table, which makes it easy to treat as background. On Pag, it deserves more attention. The island’s olive story is especially visible around Lun and its remarkable ancient olive landscape.",
      strong: [
        "olive oil",
        "Lun",
        "ancient olive landscape"
      ],
      links: [
        {
          text: "Pag olive oil producers",
          href: "https://visitnovalja.hr/agricultural-family-farm-krunoslav-vidas/?lang=en",
          external: true
        }
      ],
    },

    {
      type: "paragraph",
      text:
        "When a restaurant or producer serves its own oil, taste it first with bread. Notice the fruitiness, bitterness and peppery finish before pouring it over the rest of the meal.",
      strong: [
        "taste it first with bread",
        "fruitiness",
        "bitterness",
        "peppery finish"
      ],
    },

    {
      type: "heading",
      text: "7. Žutica, Gegić and the Wine Story of Pag",
    },

    {
      type: "paragraph",
      text:
        "Pag is better known for cheese than wine, but vines and winemaking have been part of the island for centuries. The traditional white wine known as Žutica took its name from its deep yellow colour, while Gegić remains the grape name most closely linked with Pag’s wine identity.",
      strong: [
        "Žutica",
        "Gegić",
        "Pag’s wine identity"
      ],
      links: [
        {
          text: "Žutica",
          href: "https://tzgpag.hr/en/vodic/gastronomija/42-vino-%C5%BEutica.html",
          external: true
        }
      ],
    },

    {
      type: "paragraph",
      text:
        "Ask whether the restaurant has a wine from Pag rather than automatically choosing the most familiar Croatian label. A local white beside seafood, young cheese or a lighter pizza is already a very good place to begin.",
      strong: [
        "a wine from Pag",
        "seafood",
        "young cheese",
        "lighter pizza"
      ],
    },

    {
      type: "heading",
      text: "8. Pag Salt: The Flavour Inside Every Other Flavour",
    },

    {
      type: "paragraph",
      text:
        "Salt is rarely presented as the main course, yet it sits inside nearly every important Pag food story. The island’s salt-making tradition reaches back more than a thousand years and helped shape the development of the town itself.",
      strong: [
        "Pag food story",
        "more than a thousand years",
        "salt-making tradition"
      ],
      links: [
        {
          text: "Pag’s salt-making tradition",
          href: "https://solana-pag.hr/?lang=en",
          external: true
        }
      ],
    },

    {
      type: "paragraph",
      text:
        "Try ordinary sea salt and fleur de sel if the opportunity appears. Once you understand salt’s place on Pag, you begin noticing it in the cheese, the herbs, the air and the character of almost everything else you eat.",
      strong: [
        "sea salt",
        "fleur de sel",
        "everything else you eat"
      ],
    },

    {
      type: "heading",
      text: "9. Pizza in Pag: Local Ingredients on a Different Stage",
    },

    {
      type: "paragraph",
      text:
        "Traditional food matters because it preserves knowledge. But respecting tradition does not require every local ingredient to remain inside the same presentation forever. Pizza gives Pag cheese, skuta, herbs, olive oil and salt another stage without hiding where they came from.",
      strong: [
        "Pizza in Pag",
        "Pag cheese",
        "skuta",
        "olive oil"
      ],
    },

    {
      type: "paragraph",
      text:
        "At D10’s Pizza Fantasista, the dough and technique are rooted in Neapolitan pizza, including the large, thin Ruota di Carro style. The local identity comes through the ingredients, the setting and the way the menu connects pizza with the island and football.",
      strong: [
        "D10’s Pizza Fantasista",
        "Neapolitan pizza",
        "Ruota di Carro",
        "local identity"
      ],
      links: [
        {
          text: "D10 menu",
          href: "/menu/"
        }
      ],
    },

    {
      type: "paragraph",
      text:
        "The Dalma is the clearest place to start if you want a pizza with Paški sir. Kaloka Vege goes further into the island pantry with Paški sir, skuta, rosemary, garlic and olive oil. They are not attempts to replace traditional Pag food. They show what those flavours can become in a modern pizzeria.",
      strong: [
        "pizza with Paški sir",
        "Kaloka Vege",
        "modern pizzeria"
      ],
    },

    {
      type: "quote",
      text:
        "Tradition tells us what Pag has always tasted like. Creativity asks what else those flavours can become.",
    },

    {
      type: "heading",
      text: "Where to Eat Pizza in Pag: D10’s Pizza Fantasista",
    },

    {
      type: "paragraph",
      text:
        "For visitors searching for a pizzeria in Pag, D10’s Pizza Fantasista is located at Prosika 51A, directly beside Prosika Beach and within walking distance of Pag’s old town. It is a beachside pizzeria built around carefully fermented dough, Ruota di Carro pizza, local ingredients and a football-inspired identity.",
      strong: [
        "pizzeria in Pag",
        "D10’s Pizza Fantasista",
        "Prosika 51A",
        "Prosika Beach"
      ],
      links: [
        {
          text: "get directions to D10",
          href: "https://www.google.com/maps/search/?api=1&query=D10%27s+Pizza+Fantasista+Prosika+51A+Pag",
          external: true
        }
      ],
    },

    {
      type: "paragraph",
      text:
        "There is no honest universal answer to the search for the best pizza in Pag. Some people want a classic Margherita, others want local ingredients, a large Ruota di Carro, a table near the sea or a place where dinner naturally becomes the rest of the evening. D10 is designed for that combination.",
      strong: [
        "best pizza in Pag",
        "classic Margherita",
        "local ingredients",
        "table near the sea"
      ],
    },

    {
      type: "paragraph",
      text:
        "Come after the beach, after a walk through town or simply because you want pizza made properly without turning the evening into a formal occasion. You can explore the full menu before arriving, or contact the team when visiting with a larger group.",
      strong: [
        "pizza made properly",
        "full menu",
        "larger group"
      ],
      links: [
        {
          text: "explore the full menu",
          href: "/menu/"
        },
        {
          text: "contact D10",
          href: "/contact"
        }
      ],
    },

    {
      type: "heading",
      text: "How to Eat Well in Pag",
    },

    {
      type: "paragraph",
      text:
        "You do not need to complete this list in one heroic dinner. Begin with Paški sir and local wine. Make lamb the centre of a long lunch. Order seafood when the day’s catch looks right. Look for skuta while it is available. Take baškotini home. Taste the olive oil before pouring it.",
      strong: [
        "Paški sir",
        "local wine",
        "lamb",
        "seafood",
        "skuta",
        "baškotini"
      ],
    },

    {
      type: "paragraph",
      text:
        "Then try a modern dish that uses Pag ingredients without disguising them. That may be a contemporary restaurant plate, a dessert built around skuta or a pizza where Paški sir gives the final bite its unmistakable island character.",
      strong: [
        "modern dish",
        "Pag ingredients",
        "pizza",
        "Paški sir"
      ],
    },

    {
      type: "paragraph",
      text:
        "Most importantly, ask questions. Ask where the cheese came from, whether the oil is local, what fish is fresh, which wine was made on the island and why a particular ingredient belongs in the dish.",
      strong: [
        "ask questions"
      ],
    },

    {
      type: "heading",
      text: "Frequently Asked Questions About Eating in Pag",
    },

    {
      type: "heading",
      text: "What is the most famous food in Pag?",
    },

    {
      type: "paragraph",
      text:
        "Paški sir is Pag’s most internationally recognized food. Pag lamb, skuta, baškotini, local olive oil, salt and fresh Adriatic seafood are also essential parts of the island’s food identity.",
      strong: [
        "Paški sir",
        "Pag lamb",
        "skuta",
        "baškotini"
      ],
    },

    {
      type: "heading",
      text: "Where can I eat pizza in Pag?",
    },

    {
      type: "paragraph",
      text:
        "D10’s Pizza Fantasista is a beachside pizzeria at Prosika 51A in the town of Pag. The menu focuses on Neapolitan craft and Ruota di Carro pizza, with options that include local ingredients such as Paški sir.",
      strong: [
        "D10’s Pizza Fantasista",
        "Prosika 51A",
        "Neapolitan craft",
        "Paški sir"
      ],
      links: [
        {
          text: "view the D10 pizza menu",
          href: "/menu/"
        }
      ],
    },

    {
      type: "heading",
      text: "Which D10 pizza should I try for a taste of Pag?",
    },

    {
      type: "paragraph",
      text:
        "Start with Dalma if you want Paški sir paired with Dalmatian prosciutto, arugula and cherry tomatoes on an olive oil base. Kaloka Vege is the more ingredient-driven island interpretation, combining Paški sir, skuta, rosemary, garlic and olive oil.",
      strong: [
        "Dalma",
        "Paški sir",
        "Kaloka Vege",
        "skuta"
      ],
      links: [
        {
          text: "see Dalma",
          href: "/menu/dalma/"
        }
      ],
    },

    {
      type: "heading",
      text: "Is D10 close to the centre of Pag?",
    },

    {
      type: "paragraph",
      text:
        "Yes. D10 is on Prosika Beach, on the seaside promenade connecting the older and newer parts of the town. It works well for lunch after the beach, dinner after walking through Pag or a longer evening beside the sea.",
      strong: [
        "Prosika Beach",
        "seaside promenade",
        "dinner",
        "beside the sea"
      ],
    },

    {
      type: "paragraph",
      text:
        "The best answer to what to eat in Pag is not one plate or one famous product. It is the connection between all of them. Salt settles on the herbs. Sheep eat those herbs and produce the milk used for cheese. The cheese appears beside local wine, inside traditional meals and on top of new pizzas. The sea provides lunch. Olive trees provide oil. A convent biscuit carries the story home.",
      strong: [
        "what to eat in Pag",
        "the connection between all of them",
        "new pizzas"
      ],
    },

    {
      type: "paragraph",
      text:
        "That is what food in Pag really tastes like: not a collection of separate specialties, but one island quietly appearing in every course.",
      strong: [
        "one island quietly appearing in every course"
      ],
    },
  ],
},
{
  id: 25,
  featured: false,
  slug: "one-perfect-food-day-in-pag",
  category: "Guide",

  title: "One Day in Pag: The Perfect Food Itinerary",

  subtitle:
    "Morning coffee in the old town, a light beach lunch, one local tasting, sunset pizza at D10 and a final drink by the water — this is how to eat your way through Pag in 24 hours.",

  excerpt:
    "Only have one day in Pag? Follow this practical food itinerary from morning coffee and a beach lunch to a local tasting, sunset pizza at D10 and an evening drink beside the sea.",

  author: "D10 Editorial",
  role: "Pag Food Itinerary",
  date: "July 16, 2025",
  readTime: "9 min read",

  datePublished: "2025-07-16",
  dateModified: "2025-07-16",

  seo: {
    title: "One Day in Pag: Food Itinerary & Where to Eat",
    description:
      "Plan one perfect food day in Pag: morning coffee, beach lunch, a local tasting, sunset pizza at D10 and an evening drink by the sea.",
    canonical:
      "https://www.d10s.pizza/blog/one-perfect-food-day-in-pag/",
    focusKeyword: "one day in Pag",
    secondaryKeywords: [
      "Pag food itinerary",
      "where to eat in Pag for one day",
      "24 hours in Pag",
      "one day Pag itinerary",
      "food tour Pag",
      "pizza in Pag",
      "sunset dinner Pag",
      "D10 Pizza Fantasista"
    ]
  },

  heroImage: "/img/articles/pag-view.jpg",
  image: "/img/articles/pag-view.jpg",
  author_image: "/logo2.avif",

  tags: [
    "One Day in Pag",
    "Pag Food Itinerary",
    "Where to Eat in Pag",
    "24 Hours in Pag",
    "Pizza in Pag",
    "Sunset Dinner Pag",
    "D10 Pizza Fantasista"
  ],

  keyStats: [
    { value: "24h", label: "One Complete Pag Day" },
    { value: "5", label: "Food Stops and Rituals" },
    { value: "1", label: "Sunset Pizza Finale" },
  ],

  body: [
    {
      type: "paragraph",
      dropcap: true,
      text:
        "If you only have one day in Pag, do not spend it chasing a list of restaurants across the island. Build the day around a rhythm instead: coffee before the streets become busy, lunch close to the sea, one local tasting in the afternoon, pizza when the light begins to soften, and a final drink after nobody is checking the time.",
      strong: [
        "one day in Pag",
        "build the day around a rhythm",
        "pizza when the light begins to soften"
      ],
    },

    {
      type: "paragraph",
      text:
        "This Pag food itinerary is designed for visitors staying in or near the town of Pag. Most of the day can be completed on foot, which means the food never feels separate from the beaches, stone streets, waterfront and slow summer movement that brought you here in the first place.",
      strong: [
        "Pag food itinerary",
        "town of Pag",
        "completed on foot"
      ],
    },

    {
      type: "paragraph",
      text:
        "It is not a ranking of the best restaurants in Pag. Rankings usually answer one meal. This itinerary answers the more useful question: if you arrive with only 24 hours, how should the entire day taste?",
      strong: [
        "best restaurants in Pag",
        "only 24 hours",
        "how should the entire day taste"
      ],
    },

    {
      type: "quote",
      text:
        "One good day in Pag should begin with coffee, pass through the sea, and end later than you planned.",
    },

    {
      type: "heading",
      text: "The One-Day Pag Food Itinerary at a Glance",
    },

    {
      type: "list",
      tone: "card",
      items: [
        {
          text:
            "08:00 — Coffee and a simple breakfast in the old town, before the heat and crowds arrive.",
          strong: ["08:00", "Coffee and a simple breakfast"]
        },
        {
          text:
            "10:00 — Walk, swim or wander without immediately turning the morning into another meal.",
          strong: ["10:00", "Walk, swim or wander"]
        },
        {
          text:
            "12:30 — A light lunch near the beach, built around something fresh rather than something enormous.",
          strong: ["12:30", "A light lunch near the beach"]
        },
        {
          text:
            "15:30 — One focused local tasting: cheese, olive oil, salt or another product with a real Pag story.",
          strong: ["15:30", "One focused local tasting"]
        },
        {
          text:
            "19:30 — Sunset pizza at D10’s Pizza Fantasista on Prosika Beach.",
          strong: ["19:30", "Sunset pizza", "D10’s Pizza Fantasista"]
        },
        {
          text:
            "22:00 — A final drink beside the water or back in the old town.",
          strong: ["22:00", "A final drink"]
        }
      ],
    },

    {
      type: "heading",
      text: "08:00 — Start with Coffee, Not a Challenge",
    },

    {
      type: "paragraph",
      text:
        "The temptation in a food itinerary is to make every stop feel important. Resist it. A perfect day does not need to begin with a tasting menu disguised as breakfast.",
      strong: [
        "A perfect day",
        "does not need to begin with a tasting menu"
      ],
    },

    {
      type: "paragraph",
      text:
        "Find a café around the historic centre, order coffee, take a table outside and let the town wake up around you. Add something small from a nearby bakery if you are hungry: a pastry, bread, a simple sandwich or whatever looks freshest that morning.",
      strong: [
        "historic centre",
        "coffee",
        "something small"
      ],
    },

    {
      type: "paragraph",
      text:
        "This is not the moment to force a supposedly traditional Pag breakfast simply because you are travelling. The local character comes from the setting as much as the order: stone façades still in shade, delivery vans completing their rounds, people greeting each other across the square and the first serious heat waiting just beyond the morning.",
      strong: [
        "The local character comes from the setting",
        "stone façades still in shade"
      ],
    },

    {
      type: "paragraph",
      text:
        "Keep breakfast light for one practical reason: the day becomes much better when hunger returns naturally before lunch instead of every meal arriving on top of the previous one.",
      strong: [
        "Keep breakfast light",
        "hunger returns naturally"
      ],
    },

    {
      type: "heading",
      text: "09:00 — Walk Through Pag Before It Becomes Hot",
    },

    {
      type: "paragraph",
      text:
        "After coffee, walk through the old town rather than ordering a second breakfast. Cross the square, follow the narrow streets toward the waterfront and allow yourself to get slightly lost. Pag is compact enough that getting lost rarely becomes a logistical problem.",
      strong: [
        "walk through the old town",
        "toward the waterfront",
        "compact enough"
      ],
    },

    {
      type: "paragraph",
      text:
        "The morning walk matters to the food itinerary because it gives the day context. Salt warehouses stand at Prosika opposite the historic core, a reminder that one of Pag’s defining ingredients is also part of the town’s architecture and economy.",
      strong: [
        "Salt warehouses",
        "Prosika",
        "part of the town’s architecture"
      ],
      links: [
        {
          text: "Pag’s historic salt warehouses",
          href: "https://tzgpag.hr/en/vodic/znamenitosti.html?start=6",
          external: true
        }
      ],
    },

    {
      type: "paragraph",
      text:
        "You can also visit the Pag Lace Gallery or the permanent salt exhibition if you want a cultural stop, but do not over-program the morning. The point is to understand the place without turning 24 hours into a race against a checklist.",
      strong: [
        "Pag Lace Gallery",
        "permanent salt exhibition",
        "without turning 24 hours into a race"
      ],
      links: [
        {
          text: "Pag Lace Gallery",
          href: "https://tzgpag.hr/en/vodic/stalne-izlo%C5%BEbe/53-galerija-pa%C5%A1ke-%C4%8Dipke.html",
          external: true
        },
        {
          text: "permanent salt exhibition",
          href: "https://tzgpag.hr/en/vodic/stalne-izlo%C5%BEbe/51-stalna-izlo%C5%BEba-solarstva.html",
          external: true
        }
      ],
    },

    {
      type: "heading",
      text: "10:30 — Make Space for the Sea",
    },

    {
      type: "paragraph",
      text:
        "A food day in Pag still needs time when you are not eating. Head toward Prosika Beach or another nearby swimming spot and give the late morning to the sea.",
      strong: [
        "food day in Pag",
        "Prosika Beach",
        "give the late morning to the sea"
      ],
    },

    {
      type: "paragraph",
      text:
        "Swim, read, walk along the promenade or do absolutely nothing for a while. This is not empty time between restaurant bookings. It is the part that makes the next meal feel connected to a holiday rather than to a spreadsheet.",
      strong: [
        "do absolutely nothing",
        "connected to a holiday",
        "rather than to a spreadsheet"
      ],
    },

    {
      type: "paragraph",
      text:
        "Carry water, stay out of the strongest sun when necessary and avoid turning every beach stop into cocktails before lunch. There will be enough time for drinks later.",
      strong: [
        "Carry water",
        "enough time for drinks later"
      ],
    },

    {
      type: "heading",
      text: "12:30 — Choose a Beach Lunch You Can Recover From",
    },

    {
      type: "paragraph",
      text:
        "Lunch should taste like the coast without cancelling the rest of the day. Look for a table near the sea and choose something fresh, direct and relatively light.",
      strong: [
        "Lunch should taste like the coast",
        "fresh",
        "direct",
        "relatively light"
      ],
    },

    {
      type: "paragraph",
      text:
        "That might mean grilled fish with vegetables, squid with a salad, a cold seafood plate, a simple pasta or a vegetable-led lunch with good bread and olive oil. Ask what is fresh rather than searching for the longest menu.",
      strong: [
        "grilled fish",
        "squid with a salad",
        "what is fresh"
      ],
    },

    {
      type: "paragraph",
      text:
        "The strategic mistake is ordering the heaviest possible version of island cuisine at midday because you are afraid this may be your only chance. It will not feel strategic when you are asleep at 16:00 and no longer interested in dinner.",
      strong: [
        "The strategic mistake",
        "asleep at 16:00",
        "no longer interested in dinner"
      ],
    },

    {
      type: "paragraph",
      text:
        "Have one glass of local wine if it suits the moment, but let water do most of the work. Pag afternoons are better when lunch leaves you satisfied rather than defeated.",
      strong: [
        "one glass of local wine",
        "satisfied rather than defeated"
      ],
    },

    {
      type: "quote",
      text:
        "The best lunch on a one-day itinerary is the one that still leaves the evening something to prove.",
    },

    {
      type: "heading",
      text: "14:00 — Take the Long Way Back",
    },

    {
      type: "paragraph",
      text:
        "Do not move directly from lunch to the next tasting. Walk along the water, return to the beach, find shade or go back to your accommodation for an hour. A short pause is part of the itinerary, not evidence that the plan has failed.",
      strong: [
        "Do not move directly",
        "A short pause is part of the itinerary"
      ],
    },

    {
      type: "paragraph",
      text:
        "This is also the best moment to decide how ambitious the afternoon should be. Visitors without a car can keep everything inside the town of Pag. Visitors with transport can use the next block for a producer visit elsewhere on the island, provided they confirm availability in advance.",
      strong: [
        "without a car",
        "inside the town of Pag",
        "confirm availability in advance"
      ],
    },

    {
      type: "heading",
      text: "15:30 — Choose One Local Tasting, Not Five",
    },

    {
      type: "paragraph",
      text:
        "The afternoon is where many itineraries become greedy. Cheese, olive oil, wine, salt, honey and every regional product are placed into a single tasting marathon until none of them has room to be remembered.",
      strong: [
        "where many itineraries become greedy",
        "single tasting marathon",
        "room to be remembered"
      ],
    },

    {
      type: "paragraph",
      text:
        "Choose one. Visit a local shop or producer and ask to compare two ages of Paški sir. Taste olive oil properly with bread. Explore Pag salt and fleur de sel. The objective is not to complete the island; it is to understand one product better than you did that morning.",
      strong: [
        "Choose one",
        "compare two ages of Paški sir",
        "understand one product better"
      ],
    },

    {
      type: "paragraph",
      text:
        "A good tasting should include conversation. Ask where the product was made, what changes through the season, how locals use it at home and what the producer would pair it with. Those answers usually stay with you longer than another photograph of a tasting board.",
      strong: [
        "include conversation",
        "what changes through the season",
        "stay with you longer"
      ],
    },

    {
      type: "paragraph",
      text:
        "For a separate guide to the ingredients and dishes worth looking for across the island, read our article on what to eat in Pag. This itinerary deliberately avoids repeating the full list.",
      strong: [
        "what to eat in Pag",
        "avoids repeating the full list"
      ],
      links: [
        {
          text: "what to eat in Pag",
          href: "/blog/what-to-eat-in-pag-local-food-guide/"
        }
      ],
    },

    {
      type: "heading",
      text: "17:00 — The Necessary Nothing Hour",
    },

    {
      type: "paragraph",
      text:
        "Between the tasting and dinner, schedule almost nothing. Go for another swim. Sit near the water. Return to your room, shower and change. Have an espresso if the evening still feels far away.",
      strong: [
        "schedule almost nothing",
        "another swim",
        "shower and change"
      ],
    },

    {
      type: "paragraph",
      text:
        "This pause is what prevents sunset dinner from feeling like the fifth appointment in a corporate calendar. By the time you begin walking toward Prosika, the temperature should be softer, the beach should be changing mood and hunger should have returned.",
      strong: [
        "prevents sunset dinner",
        "walking toward Prosika",
        "hunger should have returned"
      ],
    },

    {
      type: "heading",
      text: "19:30 — Sunset Pizza at D10’s Pizza Fantasista",
    },

    {
      type: "paragraph",
      text:
        "Dinner is the anchor of the day. D10’s Pizza Fantasista sits directly on Prosika Beach, close enough to the old town to reach on foot and close enough to the sea that the evening never feels separated from the rest of Pag.",
      strong: [
        "Dinner is the anchor",
        "D10’s Pizza Fantasista",
        "Prosika Beach",
        "reach on foot"
      ],
      links: [
        {
          text: "D10’s Pizza Fantasista",
          href: "/"
        },
        {
          text: "get directions",
          href: "https://www.google.com/maps/search/?api=1&query=D10%27s+Pizza+Fantasista+Prosika+51A+Pag",
          external: true
        }
      ],
    },

    {
      type: "paragraph",
      text:
        "Arrive around sunset rather than after dark. The beach is still active, the light begins to move across the water and dinner becomes the transition between day and night instead of simply another stop for food.",
      strong: [
        "Arrive around sunset",
        "transition between day and night"
      ],
    },

    {
      type: "paragraph",
      text:
        "After a day that has already included local flavours, you have two good strategies. Keep the pizza classic and judge the fundamentals with a Margherita, or choose one of D10’s island-facing combinations where ingredients such as Paški sir connect the pizza more directly with Pag.",
      strong: [
        "two good strategies",
        "Margherita",
        "Paški sir",
        "more directly with Pag"
      ],
      links: [
        {
          text: "explore the D10 menu",
          href: "/menu/"
        }
      ],
    },

    {
      type: "paragraph",
      text:
        "Do not order as though this is your last meal before a long sea voyage. Share a starter if the table wants one, choose the pizza you actually want and leave enough room for the evening to continue. The objective is not to defeat dinner. It is to stay.",
      strong: [
        "the pizza you actually want",
        "leave enough room",
        "It is to stay"
      ],
    },

    {
      type: "paragraph",
      text:
        "D10 is built for that kind of evening: slowly fermented dough, Ruota di Carro pizza, cold drinks, football details and a beachside setting where a planned meal can quietly become the main memory of the day.",
      strong: [
        "slowly fermented dough",
        "Ruota di Carro pizza",
        "beachside setting",
        "main memory of the day"
      ],
      links: [
        {
          text: "the story behind D10",
          href: "/about"
        }
      ],
    },

    {
      type: "quote",
      text:
        "The perfect final meal in Pag should feel less like the end of an itinerary and more like the reason you stopped checking it.",
    },

    {
      type: "heading",
      text: "22:00 — One More Drink, Somewhere You Can Walk From",
    },

    {
      type: "paragraph",
      text:
        "After dinner, do not immediately call the day complete. Walk back along the waterfront or continue toward the old town and choose one place for a final drink.",
      strong: [
        "Walk back along the waterfront",
        "one place for a final drink"
      ],
    },

    {
      type: "paragraph",
      text:
        "Order local wine, a spritz, beer, something non-alcoholic or simply another bottle of water. The drink matters less than the decision to sit outside and allow the day to finish slowly.",
      strong: [
        "local wine",
        "something non-alcoholic",
        "finish slowly"
      ],
    },

    {
      type: "paragraph",
      text:
        "Pag at night is compact, social and easy to continue on foot. A square that felt practical in the morning becomes a place for people-watching. The waterfront cools. The conversations become longer. Nobody needs another major plan.",
      strong: [
        "Pag at night",
        "continue on foot",
        "Nobody needs another major plan"
      ],
    },

    {
      type: "heading",
      text: "Why This Pag Food Itinerary Works",
    },

    {
      type: "paragraph",
      text:
        "The day works because it does not ask every meal to carry the entire island. Breakfast gives you the town. Lunch gives you the sea. The afternoon tasting gives you one local product in focus. D10 gives you the long sunset dinner. The final drink gives the day somewhere to land.",
      strong: [
        "Breakfast gives you the town",
        "Lunch gives you the sea",
        "D10 gives you the long sunset dinner"
      ],
    },

    {
      type: "paragraph",
      text:
        "It also keeps the route realistic. You are not driving from one end of Pag to the other between courses, arriving late everywhere and seeing most of the island through a windscreen. The town itself becomes the thread connecting the meals.",
      strong: [
        "keeps the route realistic",
        "not driving from one end of Pag to the other",
        "the thread connecting the meals"
      ],
    },

    {
      type: "paragraph",
      text:
        "Most importantly, it leaves room for the day to change. The fish available at lunch may alter your order. A producer may recommend something unexpected. The sea may keep you longer than planned. Sunset may arrive while the first pizza is reaching the table.",
      strong: [
        "leaves room for the day to change",
        "something unexpected",
        "keep you longer than planned"
      ],
    },

    {
      type: "heading",
      text: "One Day in Pag Without a Car",
    },

    {
      type: "paragraph",
      text:
        "This itinerary is easiest without a car when you base yourself in the town of Pag. The historic centre, waterfront, Prosika Beach and D10 are close enough to connect by walking, while the afternoon tasting can happen at a local shop rather than a distant producer.",
      strong: [
        "without a car",
        "town of Pag",
        "connect by walking"
      ],
    },

    {
      type: "paragraph",
      text:
        "The advantage is not only convenience. Walking keeps every part of the day visible. You notice where the beach becomes the promenade, where the historic core meets Prosika and how quickly the town changes between morning coffee and evening dinner.",
      strong: [
        "Walking keeps every part of the day visible",
        "morning coffee",
        "evening dinner"
      ],
    },

    {
      type: "heading",
      text: "One Day in Pag with a Car",
    },

    {
      type: "paragraph",
      text:
        "A car gives you the option of replacing the in-town afternoon tasting with a pre-arranged visit to a cheese, olive oil or wine producer elsewhere on the island. Keep the detour focused and allow enough time to return, rest and reach D10 before sunset.",
      strong: [
        "A car gives you the option",
        "pre-arranged visit",
        "reach D10 before sunset"
      ],
    },

    {
      type: "paragraph",
      text:
        "Do not use the car merely to collect more stops. The best upgrade is depth, not quantity: one producer, one conversation and one product understood properly.",
      strong: [
        "depth, not quantity",
        "one producer",
        "one conversation"
      ],
    },

    {
      type: "heading",
      text: "Frequently Asked Questions About One Day in Pag",
    },

    {
      type: "heading",
      text: "Is one day enough for Pag?",
    },

    {
      type: "paragraph",
      text:
        "One day is enough to experience the town of Pag, spend time by the sea and build a memorable food itinerary. It is not enough to explore the entire island properly, so resist trying to combine Pag town, Lun, Novalja, Kolan and every beach into the same 24 hours.",
      strong: [
        "enough to experience the town of Pag",
        "not enough to explore the entire island"
      ],
    },

    {
      type: "heading",
      text: "Can I Follow This Pag Food Itinerary Without Reservations?",
    },

    {
      type: "paragraph",
      text:
        "Morning coffee and a casual beach lunch are usually flexible, but summer evenings can become busy. Check current opening information and reserve dinner when visiting during peak dates, especially for a larger group or a specific sunset time.",
      strong: [
        "summer evenings can become busy",
        "check current opening information",
        "reserve dinner"
      ],
      links: [
        {
          text: "contact D10",
          href: "/contact"
        }
      ],
    },

    {
      type: "heading",
      text: "What Is the Best Time for Sunset Pizza in Pag?",
    },

    {
      type: "paragraph",
      text:
        "Aim to arrive roughly 30 to 60 minutes before sunset so the meal begins while the light is still changing. Sunset time varies considerably through the season, so check it on the day rather than relying on one fixed dinner hour.",
      strong: [
        "30 to 60 minutes before sunset",
        "check it on the day"
      ],
    },

    {
      type: "heading",
      text: "Where Should I Eat Pizza During One Day in Pag?",
    },

    {
      type: "paragraph",
      text:
        "D10’s Pizza Fantasista is at Prosika 51A beside Prosika Beach. Its location makes it a natural dinner stop after a day split between the historic centre, waterfront and beach, without requiring another drive across the island.",
      strong: [
        "D10’s Pizza Fantasista",
        "Prosika 51A",
        "natural dinner stop"
      ],
      links: [
        {
          text: "view the menu",
          href: "/menu/"
        },
        {
          text: "plan your visit",
          href: "/contact"
        }
      ],
    },

    {
      type: "heading",
      text: "What If I Am Visiting Pag with Children?",
    },

    {
      type: "paragraph",
      text:
        "Keep the same structure but make the beach block longer, the afternoon tasting shorter and dinner slightly earlier. The itinerary works because it contains open time rather than forcing children through a full day of formal food stops.",
      strong: [
        "beach block longer",
        "afternoon tasting shorter",
        "open time"
      ],
    },

    {
      type: "heading",
      text: "The Only Rule for 24 Hours in Pag",
    },

    {
      type: "paragraph",
      text:
        "Do not judge the day by how many places you managed to visit. Judge it by whether each part felt different from the one before it.",
      strong: [
        "Do not judge the day",
        "whether each part felt different"
      ],
    },

    {
      type: "paragraph",
      text:
        "Coffee should feel like the town waking up. Lunch should still carry the sea. The afternoon tasting should teach you one thing. Pizza should arrive as the sun begins to leave. The last drink should happen because nobody is ready to go home.",
      strong: [
        "Coffee",
        "Lunch",
        "afternoon tasting",
        "Pizza",
        "last drink"
      ],
    },

    {
      type: "paragraph",
      text:
        "If you only have one day in Pag, eat like this. Not everywhere. Not everything. Just enough of the island, in the right order.",
      strong: [
        "one day in Pag",
        "Not everywhere",
        "Not everything",
        "in the right order"
      ],
    },
  ],
},
{
  id: 26,
  featured: true,
  slug: "d10-pag-menu-2026-starting-eleven",
  category: "D10 Stories",

  title: "D10 Pag Menu 2026: Meet the New Starting Eleven",

  subtitle:
    "Eleven signature pizzas, six ways to play Margherita, football-inspired pasta, local Pag ingredients and drinks made for evenings beside the sea. The new season has officially started.",

  excerpt:
    "Discover the D10 Pag menu for Season 2026: eleven football-inspired Ruota di Carro pizzas, six Margherita variations, pasta, salads, local ingredients and a complete beachside drinks list.",

  author: "D10 Editorial",
  role: "Season 2026 Team Reporter",
  date: "July 25, 2026",
  readTime: "10 min read",

  datePublished: "2026-07-25",
  dateModified: "2026-07-25",

  seo: {
    title: "D10 Pag Menu 2026: Pizza Starting Eleven",
    description:
      "Explore the D10 Pag menu for 2026: eleven Ruota di Carro pizzas, six Margherita versions, pasta, Pag ingredients, cocktails and more.",
    canonical:
      "https://www.d10s.pizza/blog/d10-pag-menu-2026-starting-eleven/",
    focusKeyword: "D10 Pag menu",
    secondaryKeywords: [
      "D10 menu 2026",
      "pizza in Pag",
      "Pag pizza menu",
      "where to eat pizza in Pag",
      "Ruota di Carro Pag",
      "restaurant Prosika Beach",
      "football themed restaurant Croatia",
      "D10 Pizza Fantasista",
      "pizza restaurant Pag Croatia",
      "Prosika Pag food"
    ]
  },

  heroImage: "/img/articles/2026/menu.jpeg",
  image: "/img/articles/2026/menu.jpeg",
  author_image: "/logo2.avif",

  tags: [
    "D10 Pag Menu",
    "Season 2026",
    "Pizza in Pag",
    "Ruota di Carro",
    "Starting Eleven",
    "Prosika Beach",
    "D10 Pizza Fantasista"
  ],

  keyStats: [
    { value: "11", label: "Signature Pizzas" },
    { value: "6", label: "Ways to Play Margherita" },
    { value: "4-4-2", label: "Ruota di Carro Formation" },
  ],

  body: [
    {
      type: "paragraph",
      dropcap: true,
      text:
        "A new season at D10 does not begin with a press conference. It begins with flour on the table, tomatoes being opened, cheese arriving from the fridge and eleven pizzas waiting to earn their place in the formation.",
      strong: [
        "A new season at D10",
        "eleven pizzas",
        "earn their place in the formation"
      ],
    },

    {
      type: "paragraph",
      text:
        "The D10 Pag menu for Season 2026 is our most complete team yet: eleven signature Ruota di Carro pizzas, six interpretations of Margherita, football-inspired pasta and salads, original sweets and a drinks list designed for long evenings on Prosika Beach.",
      strong: [
        "D10 Pag menu for Season 2026",
        "eleven signature Ruota di Carro pizzas",
        "six interpretations of Margherita",
        "Prosika Beach"
      ],
      links: [
        {
          text: "view the complete D10 menu",
          href: "/menu/"
        }
      ],
    },

    {
      type: "paragraph",
      text:
        "We have presented it as La Gazzetta della Pizza: part menu, part team sheet and part football newspaper. The pizzas carry famous names, but the food always comes first. Every player gives us a way to explain the recipe — its pace, structure, confidence, simplicity or ability to cause immediate problems.",
      strong: [
        "La Gazzetta della Pizza",
        "part menu",
        "part team sheet",
        "the food always comes first"
      ],
    },

    {
      type: "quote",
      text:
        "Eleven pizzas. One formation. No guaranteed place in your starting lineup.",
    },
{
      type: "image",
      src: "/img/articles/2026/d10s_442_menu.jpg",
      alt: "The D10S",
      caption: "The D10S Menu.",
    },
    {
      type: "heading",
      text: "Why the D10 Menu Is Built Like a Football Team",
    },

    {
      type: "paragraph",
      text:
        "A normal menu gives every dish the same job: sit on a page and wait to be chosen. Our Starting Eleven works differently. Each pizza needs its own role, recognisable personality and reason to exist beside the others.",
      strong: [
        "Our Starting Eleven",
        "its own role",
        "recognisable personality"
      ],
    },

    {
      type: "paragraph",
      text:
        "Some protect the fundamentals. Some control the middle. Some arrive with smoke, heat or ingredients you did not expect. Others need almost nothing because the classics are already difficult enough to execute properly.",
      strong: [
        "protect the fundamentals",
        "smoke",
        "heat",
        "the classics"
      ],
    },

    {
      type: "paragraph",
      text:
        "Together, they form a menu that can move from a clean Marinara or Margherita to guanciale, mortadella, bresaola, Baranja kulen, Paški sir, ’nduja and smoked provola without losing its basic identity.",
      strong: [
        "Marinara or Margherita",
        "guanciale",
        "Baranja kulen",
        "Paški sir",
        "smoked provola"
      ],
    },

    {
      type: "heading",
      text: "The Starting Eleven for Season 2026",
    },

    {
      type: "paragraph",
      text:
        "The first team contains eleven signature pizzas. Prices begin at €9.80 for the most essential classics and reach €15.40 for combinations built around premium cheeses, cured meats and fresh finishing ingredients.",
      strong: [
        "eleven signature pizzas",
        "€9.80",
        "€15.40"
      ],
    },

    {
      type: "list",
      tone: "card",
      items: [
        {
          text:
            "1 — Buffon’s Marinara · €9.80 — San Marzano DOP, garlic, olive oil and oregano. No cheese, no hiding place and no unnecessary movement.",
          strong: [
            "Buffon’s Marinara",
            "€9.80",
            "San Marzano DOP"
          ]
        },
        {
          text:
            "2 — Cafu’s Margherita · €9.80 — San Marzano DOP, fior di latte, olive oil and basil. The reference point for everything that follows.",
          strong: [
            "Cafu’s Margherita",
            "fior di latte",
            "The reference point"
          ]
        },
        {
          text:
            "3 — Maldini’s Amatriciana · €13.40 — Yellow tomato, fior di latte, Amatriciana sauce and guanciale. Structured, savoury and composed.",
          strong: [
            "Maldini’s Amatriciana",
            "yellow tomato",
            "guanciale"
          ]
        },
        {
          text:
            "4 — Guardiola’s Cacio e Pepe · €13.80 — Ricotta, fior di latte, provola, gorgonzola and Paški sir. Five cheeses organised into one system.",
          strong: [
            "Guardiola’s Cacio e Pepe",
            "five cheeses",
            "Paški sir"
          ]
        },
        {
          text:
            "5 — Beckenbauer’s Classic · €12.50 — San Marzano DOP, fior di latte, prosciutto cotto and mushrooms. Familiar ingredients, complete authority.",
          strong: [
            "Beckenbauer’s Classic",
            "prosciutto cotto",
            "mushrooms"
          ]
        },
        {
          text:
            "6 — Roberto Carlos Free Kick · €13.80 — Yellow tomato, smoked provola, grilled eggplant and ’nduja. Bright, smoky and difficult to predict.",
          strong: [
            "Roberto Carlos Free Kick",
            "smoked provola",
            "grilled eggplant",
            "’nduja"
          ]
        },
        {
          text:
            "7 — Ronaldo’s Marine Predator · €14.50 — San Marzano DOP, mozzarella di bufala, tuna, purple onion and pepper drops.",
          strong: [
            "Ronaldo’s Marine Predator",
            "mozzarella di bufala",
            "tuna"
          ]
        },
        {
          text:
            "8 — Prosikito’s Mortadella · €14.80 — Ricotta, mortadella, stracciatella and pistachio sauce. Creamy, generous and made for Prosika.",
          strong: [
            "Prosikito’s Mortadella",
            "stracciatella",
            "pistachio sauce"
          ]
        },
        {
          text:
            "9 — Mo Salah’s Bresaola · €15.40 — San Marzano DOP, mozzarella di bufala, rocket, bresaola, yellow cherry tomatoes and Paški sir.",
          strong: [
            "Mo Salah’s Bresaola",
            "bresaola",
            "yellow cherry tomatoes",
            "Paški sir"
          ]
        },
        {
          text:
            "10 — Dalma · €15.20 — Fior di latte, rocket, Croatian prosciutto, cherry tomatoes and Paški sir. A direct connection between the pizza and the island around it.",
          strong: [
            "Dalma",
            "Croatian prosciutto",
            "Paški sir",
            "the island around it"
          ]
        },
        {
          text:
            "11 — Beckham’s Diavola · €14.80 — San Marzano DOP, Baranja kulen, stracciatella, ’nduja and red pepper drops. Style, heat and a serious final ball.",
          strong: [
            "Beckham’s Diavola",
            "Baranja kulen",
            "stracciatella",
            "heat"
          ]
        }
      ],
    },

    {
      type: "paragraph",
      text:
        "The objective was not to create eleven pizzas that compete to be the loudest. A proper team needs contrast. Marinara must remain simple. Margherita must remain recognisable. A cheese-led pizza should not taste like a spicy one, and local ingredients should feel integrated rather than added as souvenirs.",
      strong: [
        "A proper team needs contrast",
        "Marinara must remain simple",
        "local ingredients should feel integrated"
      ],
    },

    {
      type: "quote",
      text:
        "A good menu is not eleven versions of the same idea. It is eleven different reasons to return.",
    },

    {
      type: "heading",
      text: "The Queen of All Pizzas, Available Six Ways",
    },

    {
      type: "paragraph",
      text:
        "Margherita deserves more than one line in the formation. It is the pizza most people recognise, the one many use to judge a pizzeria and the recipe with nowhere to hide weak dough, poor tomato or careless cheese.",
      strong: [
        "Margherita",
        "the one many use to judge a pizzeria",
        "nowhere to hide"
      ],
    },

    {
      type: "paragraph",
      text:
        "Cafu’s Margherita is the starting point: San Marzano DOP, fior di latte, olive oil and basil. From there, five additional versions allow the same basic shape to move in different directions.",
      strong: [
        "Cafu’s Margherita",
        "the starting point",
        "five additional versions"
      ],
    },

    {
      type: "list",
      tone: "card",
      items: [
        {
          text:
            "Neville Twins Bufala · €10.80 — San Marzano DOP, fior di latte, mozzarella di bufala and basil.",
          strong: [
            "Neville Twins Bufala",
            "mozzarella di bufala"
          ]
        },
        {
          text:
            "Lo Zio’s Provola · €10.80 — San Marzano DOP, smoked provola and basil.",
          strong: [
            "Lo Zio’s Provola",
            "smoked provola"
          ]
        },
        {
          text:
            "Spicy Salgado’s ’Nduja · €10.80 — San Marzano DOP, fior di latte, ’nduja and basil.",
          strong: [
            "Spicy Salgado’s ’Nduja",
            "’nduja"
          ]
        },
        {
          text:
            "Bellerin’s Green · €10.80 — San Marzano DOP, vegan mozzarella and basil.",
          strong: [
            "Bellerin’s Green",
            "vegan mozzarella"
          ]
        },
        {
          text:
            "Kaloka, Pag’s Margherita · €12.50 — San Marzano DOP, Paški sir, Pag skuta, rosemary and young onion.",
          strong: [
            "Kaloka, Pag’s Margherita",
            "Paški sir",
            "Pag skuta"
          ]
        }
      ],
    },

    {
      type: "paragraph",
      text:
        "This makes Margherita useful for very different tables. One guest can stay completely classic, another can choose buffalo mozzarella, another wants smoke, another wants heat, and another wants the version that speaks most directly about Pag.",
      strong: [
        "stay completely classic",
        "smoke",
        "heat",
        "speaks most directly about Pag"
      ],
    },

    {
      type: "heading",
      text: "Ruota di Carro: The Shape Behind the Formation",
    },

    {
      type: "paragraph",
      text:
        "The Starting Eleven is built around Ruota di Carro pizza: broad, thin through the centre and extending generously toward the edge of the plate. The name translates as cartwheel, which explains the unmistakable size and shape before the first slice is lifted.",
      strong: [
        "Ruota di Carro pizza",
        "broad",
        "thin through the centre",
        "cartwheel"
      ],
    },

    {
      type: "paragraph",
      text:
        "Size alone is not the point. The dough still needs balance: enough structure to carry the ingredients, enough softness to fold, and enough character in the crust that the final bites do not feel like leftovers from the centre.",
      strong: [
        "Size alone is not the point",
        "enough structure",
        "enough softness",
        "character in the crust"
      ],
    },

    {
      type: "paragraph",
      text:
        "That balance becomes especially important across this menu because the toppings move from minimal Marinara to soft cheeses, cured meats, vegetables, spicy sausage and finishing ingredients added for freshness.",
      strong: [
        "minimal Marinara",
        "soft cheeses",
        "cured meats",
        "finishing ingredients"
      ],
    },

    {
      type: "heading",
      text: "Italian Foundations, Ingredients from Pag",
    },

    {
      type: "paragraph",
      text:
        "The D10 menu begins with Italian foundations: San Marzano DOP tomatoes, fior di latte, mozzarella di bufala, smoked provola, guanciale, stracciatella, mortadella, bresaola and ’nduja.",
      strong: [
        "Italian foundations",
        "San Marzano DOP tomatoes",
        "fior di latte",
        "stracciatella",
        "’nduja"
      ],
    },

    {
      type: "paragraph",
      text:
        "But D10 is not located in an anonymous dining room that could belong to any city. We are on Prosika Beach in Pag, and the island needs to remain visible in the food.",
      strong: [
        "Prosika Beach",
        "Pag",
        "the island needs to remain visible"
      ],
    },

    {
      type: "paragraph",
      text:
        "Paški sir appears across several pizzas. Pag skuta, rosemary and young onion turn Kaloka into our island interpretation of Margherita. Croatian prosciutto leads Dalma. Pag flower of salt reaches the cocktail list through the Salted Botanical GT.",
      strong: [
        "Paški sir",
        "Pag skuta",
        "Croatian prosciutto",
        "Pag flower of salt"
      ],
    },

    {
      type: "paragraph",
      text:
        "The point is not to place a local ingredient on everything. It is to use it where it changes the recipe for a reason. Pag should be present in the menu as flavour, not as decoration.",
      strong: [
        "not to place a local ingredient on everything",
        "changes the recipe for a reason",
        "flavour, not as decoration"
      ],
    },

    {
      type: "heading",
      text: "Not Every Player Is a Pizza",
    },

    {
      type: "paragraph",
      text:
        "Sometimes the table needs a substitute. The Season 2026 menu includes pasta, chicken, salads and sweets for moments when pizza is not the only plan.",
      strong: [
        "the table needs a substitute",
        "pasta",
        "chicken",
        "salads",
        "sweets"
      ],
    },

    {
      type: "heading",
      text: "The Substitutes",
    },

    {
      type: "list",
      tone: "card",
      items: [
        {
          text:
            "Spaghetti all’Amatriciana · €13.80 — Amatriciana sauce, guanciale and Paški sir.",
          strong: [
            "Spaghetti all’Amatriciana",
            "guanciale",
            "Paški sir"
          ]
        },
        {
          text:
            "Tiki-Taka Penne · €12.50 — Penne with ricotta, bell pepper, tomato, onion and garlic sauce.",
          strong: [
            "Tiki-Taka Penne",
            "ricotta",
            "bell pepper"
          ]
        },
        {
          text:
            "Fusilli Calcio e Pepe · €14.20 — Gluten-free fusilli with cacio e pepe sauce and basil.",
          strong: [
            "Fusilli Calcio e Pepe",
            "gluten-free fusilli",
            "cacio e pepe"
          ]
        },
        {
          text:
            "Spin-Ach-O Chicken · €13.30 — Pasta with spinach and chicken.",
          strong: [
            "Spin-Ach-O Chicken",
            "spinach and chicken"
          ]
        }
      ],
    },

    {
      type: "heading",
      text: "The Referees",
    },

    {
      type: "list",
      tone: "card",
      items: [
        {
          text:
            "Collina Caprese Salad · €11.20 — Mozzarella, tomato, basil and olive oil.",
          strong: [
            "Collina Caprese Salad",
            "Mozzarella",
            "tomato",
            "basil"
          ]
        },
        {
          text:
            "Júlio César’s Salad · €13.40 — Mozzarella, chicken, seasonal vegetables and dressing.",
          strong: [
            "Júlio César’s Salad",
            "chicken",
            "seasonal vegetables"
          ]
        },
        {
          text:
            "Chicken Strips · €13.80 — Breaded chicken strips, french fries and dips.",
          strong: [
            "Chicken Strips",
            "french fries",
            "dips"
          ]
        }
      ],
    },

    {
      type: "paragraph",
      text:
        "And because every match needs a final moment, D10’s Original Sweets are the Play of the Day. Ask the waiter what is available, then decide whether the table has genuinely finished or was only pretending.",
      strong: [
        "D10’s Original Sweets",
        "Play of the Day",
        "Ask the waiter"
      ],
    },

    {
      type: "heading",
      text: "Il Messaggero delle Bevande",
    },

    {
      type: "paragraph",
      text:
        "The back page of the menu becomes Il Messaggero delle Bevande: water, soft drinks, freshly squeezed juices, coffee, beer, wine, spirits, spritz drinks and D10 cocktails presented with the same newspaper energy as the food.",
      strong: [
        "Il Messaggero delle Bevande",
        "beer",
        "wine",
        "spritz drinks",
        "D10 cocktails"
      ],
    },

    {
      type: "paragraph",
      text:
        "The list moves from espresso and San Pellegrino to Heineken, Birra Moretti, Lagunitas IPA and PA CA? APA. Wines by the glass include Croatian whites, reds, rosé and sparkling options, while Fortunal, Fortica and Paški Vermouth keep the island inside the drinks programme.",
      strong: [
        "PA CA? APA",
        "Croatian whites",
        "Fortunal",
        "Fortica",
        "Paški Vermouth"
      ],
    },

    {
      type: "paragraph",
      text:
        "Cocktails include Mojito, Moscow Mule, Pag Negroni, Pag Style Margarita, Pink Goal GT and the Salted Botanical GT made with gin, tonic and Pag flower of salt.",
      strong: [
        "Pag Negroni",
        "Pag Style Margarita",
        "Salted Botanical GT",
        "Pag flower of salt"
      ],
    },

    {
      type: "heading",
      text: "One Beer, One Small Contribution to NK Pag",
    },

    {
      type: "paragraph",
      text:
        "The PA CA? APA bottle also carries something beyond the table. For every bottle sold, €0.20 is donated to the NK Pag Football Academy.",
      strong: [
        "PA CA? APA",
        "€0.20",
        "NK Pag Football Academy"
      ],
    },

    {
      type: "paragraph",
      text:
        "It is a small contribution attached to a simple choice, but repeated across a season those choices can support football for children on the island. Eat in Pag. Drink in Pag. Leave a little something with Pag.",
      strong: [
        "support football for children",
        "Eat in Pag",
        "Drink in Pag",
        "Leave a little something with Pag"
      ],
    },

    {
      type: "quote",
      text:
        "A menu should tell you what to order. A good one should also tell you where you are.",
    },

    {
      type: "heading",
      text: "How to Choose from the D10 Pag Menu",
    },

    {
      type: "paragraph",
      text:
        "Start by deciding what kind of match you want. For the clearest test of dough, tomato and balance, choose Marinara or one of the Margheritas. For smoke, look toward provola. For heat, choose ’nduja or Beckham’s Diavola. For a softer and richer profile, move toward stracciatella, mortadella or mozzarella di bufala.",
      strong: [
        "what kind of match you want",
        "Marinara",
        "Margheritas",
        "smoke",
        "heat"
      ],
    },

    {
      type: "paragraph",
      text:
        "For something connected directly to the island, choose a pizza built with Paški sir, Pag skuta or Croatian prosciutto. For a table that wants variety, share pizzas with genuinely different profiles rather than ordering four versions built around the same ingredients.",
      strong: [
        "connected directly to the island",
        "Paški sir",
        "Pag skuta",
        "genuinely different profiles"
      ],
    },

    {
      type: "paragraph",
      text:
        "There is no objectively correct Starting Eleven. The whole point is that yours may change with the weather, the table, the hour and how long you intend to remain beside the sea.",
      strong: [
        "no objectively correct Starting Eleven",
        "the weather",
        "the table",
        "beside the sea"
      ],
    },

    {
      type: "heading",
      text: "Pizza on Prosika Beach in Pag",
    },

    {
      type: "paragraph",
      text:
        "D10’s Pizza Fantasista is located at Prosika 51A in the town of Pag, directly beside Prosika Beach and within walking distance of the historic centre.",
      strong: [
        "D10’s Pizza Fantasista",
        "Prosika 51A",
        "Prosika Beach",
        "historic centre"
      ],
      links: [
        {
          text: "get directions to D10",
          href: "https://www.google.com/maps/search/?api=1&query=D10%27s+Pizza+Fantasista+Prosika+51A+Pag",
          external: true
        }
      ],
    },

    {
      type: "paragraph",
      text:
        "That location shapes the entire experience. Pizza can begin while the beach is still active, continue through sunset and quietly turn into drinks after nobody at the table is in a hurry to leave.",
      strong: [
        "shapes the entire experience",
        "continue through sunset",
        "not in a hurry to leave"
      ],
    },

    {
      type: "paragraph",
      text:
        "Come for one pizza or bring enough people to test the formation properly. Either way, the objective is the same: good dough, serious ingredients, cold drinks, football on the walls and the sea close enough to remain part of dinner.",
      strong: [
        "test the formation",
        "good dough",
        "serious ingredients",
        "the sea"
      ],
    },

    {
      type: "heading",
      text: "Frequently Asked Questions About the D10 Pag Menu",
    },

    {
      type: "heading",
      text: "What Type of Pizza Does D10 Serve?",
    },

    {
      type: "paragraph",
      text:
        "D10 specialises in Ruota di Carro pizza, a broad Neapolitan style with a thin, soft centre and a crust that extends generously across the plate. The Season 2026 menu applies that format to eleven signature recipes and six versions of Margherita.",
      strong: [
        "Ruota di Carro pizza",
        "thin, soft centre",
        "eleven signature recipes",
        "six versions of Margherita"
      ],
    },

    {
      type: "heading",
      text: "How Much Does Pizza Cost at D10 in Pag?",
    },

    {
      type: "paragraph",
      text:
        "On the Season 2026 menu, signature pizzas range from €9.80 for Buffon’s Marinara and Cafu’s Margherita to €15.40 for Mo Salah’s Bresaola. Additional Margherita versions begin at €10.80.",
      strong: [
        "€9.80",
        "€15.40",
        "Additional Margherita versions"
      ],
    },

    {
      type: "heading",
      text: "Does D10 Have Vegetarian or Vegan Pizza?",
    },

    {
      type: "paragraph",
      text:
        "The menu includes several meat-free pizzas, including Marinara, Cafu’s Margherita, Neville Twins Bufala, Lo Zio’s Provola and Guardiola’s Cacio e Pepe. Bellerin’s Green is the menu’s explicitly vegan-labelled Margherita, made with San Marzano DOP, vegan mozzarella and basil.",
      strong: [
        "meat-free pizzas",
        "Bellerin’s Green",
        "vegan-labelled Margherita"
      ],
    },

    {
      type: "heading",
      text: "Does the Menu Include Food Other Than Pizza?",
    },

    {
      type: "paragraph",
      text:
        "Yes. The Season 2026 menu also includes pasta, chicken, salads, french fries and D10’s Original Sweets, together with a complete drinks list.",
      strong: [
        "pasta",
        "chicken",
        "salads",
        "D10’s Original Sweets"
      ],
    },

    {
      type: "heading",
      text: "Where Is D10’s Pizza Fantasista?",
    },

    {
      type: "paragraph",
      text:
        "D10’s Pizza Fantasista is at Prosika 51A in Pag, beside Prosika Beach. The restaurant can be reached on foot from the historic town centre and waterfront.",
      strong: [
        "Prosika 51A",
        "Pag",
        "Prosika Beach",
        "reached on foot"
      ],
      links: [
        {
          text: "plan your visit",
          href: "/contact"
        }
      ],
    },

    {
      type: "heading",
      text: "The Season Is Open",
    },

    {
      type: "paragraph",
      text:
        "Season 2026 is not one new pizza and it is not one headline signing. It is the full squad: classics, new combinations, local ingredients, six different Margheritas, substitutes, referees, sweets and a drinks list with enough options to take dinner well beyond the final whistle.",
      strong: [
        "Season 2026",
        "the full squad",
        "six different Margheritas",
        "beyond the final whistle"
      ],
    },

    {
      type: "paragraph",
      text:
        "Some guests will always start with Cafu. Some will go directly toward kulen, guanciale or ’nduja. Some will order the most local pizza on the page. Others will spend ten minutes studying the formation and then choose exactly what they always choose.",
      strong: [
        "kulen",
        "guanciale",
        "’nduja",
        "the most local pizza"
      ],
    },

    {
      type: "paragraph",
      text:
        "All of those approaches are valid. The menu is ready. The dough is waiting. The only selection problem left belongs to you.",
      strong: [
        "The menu is ready",
        "The dough is waiting",
        "belongs to you"
      ],
      links: [
        {
          text: "see the Season 2026 menu",
          href: "/menu/"
        },
        {
          text: "visit D10 on Prosika Beach",
          href: "/contact"
        }
        
      ],
      
      
    },
    {
      type: "image",
      src: "/img/articles/2026/desetke.jpg",
      alt: "The D10S",
      caption: "Our team of fantasistas.",
    },
  ],
},
];

// --------------------------------------------
// 2) FEATURED
// Picks the first article with featured:true,
// otherwise falls back to ARTICLES[0].
// --------------------------------------------

export const FEATURED_STORY = ARTICLES.find((a) => a.featured) || ARTICLES[0] || null;

// --------------------------------------------
// 3) HELPERS
// --------------------------------------------

export const getArticleBySlug = (slug) => ARTICLES.find((a) => a.slug === slug);

export const getNextArticle = (slug) => {
  if (!ARTICLES.length) return null;

  const i = ARTICLES.findIndex((a) => a.slug === slug);
  if (i === -1) return ARTICLES[0];

  // “next” skipping current
  return ARTICLES[(i + 1) % ARTICLES.length];
};

// ✅ Categories derived from the data (no CATEGORIES export)
export const getCategories = () => {
  const set = new Set();
  ARTICLES.forEach((a) => {
    if (a?.category) set.add(a.category);
  });

  // UI wants “All Stories” first
  return ["All Stories", ...Array.from(set),"Press"];
};
